/**
 *
 * Plans
 *
 */

import React, { memo, useState, useEffect, useCallback, useMemo } from "react";
import { Helmet } from "react-helmet";
import classNames from "classnames";

// styles
import "./style.scss";


// global user
import { withUser } from "engine/Contexts/User.context";

export function Plans({
  history,
  user,
  //rest
  className,
  ...rest
}) {

  const childClassNames = classNames("plans-page-desktop", className);

  const totalSteps = 5;

  const [planStep, setPlanStep] = useState(1);

  const nextStep = () => setPlanStep(prev => Number(prev) + 1);
  const prevStep = () =>
    planStep > 1 ? setPlanStep(prev => Number(prev) + 1) : 1;
  const plan01StepCallback = () => setPlanStep(1);
  const planSettings05StepCallback = () => setPlanStep(5);

  const step01 = useMemo(
    () => (
      <svg
        width="1349px"
        height="962px"
        viewBox="0 0 1349 962"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="step01"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect fill="#F1F3F9" x="0" y="0" width="1349" height="962" />
          <g
            id="Group-2"
            transform="translate(22.000000, 29.000000)"
            fill="#000000"
            fontFamily="Roboto-Medium, Roboto"
            fontSize="20"
            fontWeight="400"
          >
            <text id="Plans">
              <tspan x="0" y="19">
                Plans
              </tspan>
            </text>
          </g>
          <line
            x1="351.5"
            y1="158.5"
            x2="351.5"
            y2="923.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="350.5"
            y1="78.5"
            x2="0.5"
            y2="78.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="393.5"
            y1="120.5"
            x2="393.5"
            y2="923.52497"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.465966"
            y1="158.5"
            x2="1281.53403"
            y2="158.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="393.5"
            y1="120.5"
            x2="1281.53403"
            y2="120.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.5"
            y1="78.5"
            x2="1349.5"
            y2="78.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <g
            id="Group-15"
            transform="translate(462.000000, 127.000000)"
            fill="#000000"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="20"
            fontWeight="normal"
          >
            <g id="Group-14">
              <text id="Vendredi">
                <tspan x="685.063415" y="19">
                  Vendredi
                </tspan>
              </text>
              <text id="Jeudi">
                <tspan x="523.454878" y="19">
                  Jeudi
                </tspan>
              </text>
              <text id="Mercredi">
                <tspan x="369.031707" y="19">
                  Mercredi
                </tspan>
              </text>
              <text id="Mardi">
                <tspan x="174.608537" y="19">
                  Mardi
                </tspan>
              </text>
              <text id="Lundi">
                <tspan x="0" y="19">
                  Lundi
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-6" transform="translate(100.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="148"
              height="49"
              rx="10"
            />
            <text
              id="2021/2022"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                2021/2022
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(114.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy" transform="translate(259.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="Plan-de-cours"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                Plan de cours
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy-2" transform="translate(441.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="5H-B"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                5H B
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group" transform="translate(24.000000, 121.000000)">
            <g id="Group-6" transform="translate(2.000000, 175.000000)">
              <rect
                id="Rectangle"
                stroke="#999999"
                fill="#FFFFFF"
                x="0.5"
                y="0.5"
                width="261"
                height="49"
                rx="10"
              />
              <text
                id="Toutes-les-matières"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="16"
                fontWeight="400"
                fill="#000000"
              >
                <tspan x="16" y="30">
                  Toutes les matières
                </tspan>
              </text>
              <g
                id="SL/icons/icon/arrow-short"
                transform="translate(229.753170, 21.246883)"
                fill="#101010"
              >
                <path
                  d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                  id="Path"
                  transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
                />
              </g>
            </g>
            <text
              id="Matière"
              opacity="0.65"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="14"
              fontWeight="normal"
              fill="#000000"
            >
              <tspan x="2" y="161">
                Matière
              </tspan>
            </text>
            <rect
              id="Ajouter-une-entrée-Rectangle"
              onClick={nextStep}
              className="clickable-svg-part"
              fill="#F59C05"
              x="2"
              y="236"
              width="262"
              height="43"
              rx="5"
            />
            <text
              id="Ajouter-une-entrée"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#FFFFFF"
            >
              <tspan x="72.328125" y="263">
                Ajouter une entrée
              </tspan>
            </text>
            <g
              id="SL/icons/naked-icon"
              transform="translate(22.537273, 248.633333)"
              fill="#FFFFFF"
            >
              <g
                id="iconfinder_add_134224"
                transform="translate(-0.000000, 0.000000)"
              >
                <path
                  d="M17.1527778,7.6 L10.5555556,7.6 L10.5555556,1.26666667 C10.5555556,0.567466667 9.96444444,0 9.23611111,0 C8.50777778,0 7.91666667,0.567466667 7.91666667,1.26666667 L7.91666667,7.6 L1.31944444,7.6 C0.591111111,7.6 0,8.16746667 0,8.86666667 C0,9.56586667 0.591111111,10.1333333 1.31944444,10.1333333 L7.91666667,10.1333333 L7.91666667,16.4666667 C7.91666667,17.1658667 8.50777778,17.7333333 9.23611111,17.7333333 C9.96444444,17.7333333 10.5555556,17.1658667 10.5555556,16.4666667 L10.5555556,10.1333333 L17.1527778,10.1333333 C17.8811111,10.1333333 18.4722222,9.56586667 18.4722222,8.86666667 C18.4722222,8.16746667 17.8811111,7.6 17.1527778,7.6 Z"
                  id="Path"
                />
              </g>
            </g>
            <g id="Group-20">
              <text
                id="Plan"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="16"
                fontWeight="bold"
                fill="#000000"
              >
                <tspan x="13.9492188" y="15">
                  Plan
                </tspan>
              </text>
              <g id="Group-19" transform="translate(0.000000, 35.000000)">
                <line
                  x1="0.5"
                  y1="0.5"
                  x2="0.5"
                  y2="50.5"
                  id="Line-4"
                  stroke="#ECE9E9"
                  strokeLinecap="square"
                />
                <g id="Group-14" transform="translate(0.000000, 2.000000)">
                  <line
                    x1="0.5"
                    y1="0.5"
                    x2="0.5"
                    y2="16.5"
                    id="Line-4"
                    stroke="#005D9F"
                    strokeWidth="2"
                    strokeLinecap="square"
                  />
                  <text
                    id="Import-/-Export"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#8C8C8C"
                  >
                    <tspan x="15" y="44">
                      Import / Export
                    </tspan>
                  </text>
                  <text
                    id="Paramètres-Copy-first"
                    onClick={planSettings05StepCallback}
                    className="clickable-svg-part"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#8C8C8C"
                  >
                    <tspan x="15" y="78">
                      Paramètres
                    </tspan>
                  </text>
                </g>
                <text
                  id="Plan-de-cours"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="14"
                  fontWeight="bold"
                  fill="#005D9F"
                >
                  <tspan x="15" y="15">
                    Plan de cours
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="full-time-table" transform="translate(394.000000, 159.000000)">
            <g id="timeslot" transform="translate(716.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-15" transform="translate(393.500000, 120.478002)">
            <g id="Group-14-Copy-3" transform="translate(716.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Vendredi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="50.3714558" y="26">
                  Vendredi
                </tspan>
              </text>
            </g>
            <g id="Group-14-Copy-2" transform="translate(537.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Jeudi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="65.234737" y="26">
                  Jeudi
                </tspan>
              </text>
            </g>
            <g id="Group-14-Copy" transform="translate(358.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Mercredi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="50.4202839" y="26">
                  Mercredi
                </tspan>
              </text>
            </g>
            <g id="Group-14" transform="translate(179.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Mardi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="64.1019245" y="26">
                  Mardi
                </tspan>
              </text>
            </g>
            <g id="Group-14">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Lundi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="65.366573" y="26">
                  Lundi
                </tspan>
              </text>
            </g>
          </g>
          <g
            id="mobile/btn/primary/default"
            transform="translate(1117.000000, 16.000000)"
          >
            <rect
              id="Rectangle"
              fill="#005D9F"
              x="0"
              y="0"
              width="172"
              height="50"
              rx="10"
            />
            <text
              id="Primary"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#FFFFFF"
            >
              <tspan x="36.8828125" y="31">
                Nouveau plan
              </tspan>
            </text>
          </g>
          <g id="Group-9" transform="translate(352.000000, 158.000000)">
            <g id="Group-Copy-7" transform="translate(0.000000, 681.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="9"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  9
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-6" transform="translate(0.000000, 596.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="8"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  8
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-5" transform="translate(0.000000, 511.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="7"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  7
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-4" transform="translate(0.000000, 426.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="6"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  6
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-3" transform="translate(0.000000, 340.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="5"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  5
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-2" transform="translate(0.000000, 255.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="4"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  4
                </tspan>
              </text>
            </g>
            <g id="Group-Copy" transform="translate(0.000000, 170.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="3"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  3
                </tspan>
              </text>
            </g>
            <g id="Group" transform="translate(0.000000, 85.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="2"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  2
                </tspan>
              </text>
            </g>
            <g id="Group">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="1"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  1
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
    ),
    [nextStep, planSettings05StepCallback],
  );
  const step02 = useMemo(
    () => (
      <svg
        width="1349px"
        height="962px"
        viewBox="0 0 1349 962"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="step02"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect fill="#F1F3F9" x="0" y="0" width="1349" height="962" />
          <g
            id="Group-2"
            transform="translate(22.000000, 29.000000)"
            fill="#000000"
            fontFamily="Roboto-Medium, Roboto"
            fontSize="20"
            fontWeight="400"
          >
            <text id="Plans">
              <tspan x="0" y="19">
                Plans
              </tspan>
            </text>
          </g>
          <line
            x1="351.5"
            y1="158.5"
            x2="351.5"
            y2="923.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="350.5"
            y1="78.5"
            x2="0.5"
            y2="78.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="393.5"
            y1="120.5"
            x2="393.5"
            y2="923.52497"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.465966"
            y1="158.5"
            x2="1281.53403"
            y2="158.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="393.5"
            y1="120.5"
            x2="1281.53403"
            y2="120.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.5"
            y1="78.5"
            x2="1349.5"
            y2="78.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <g
            id="Group-15"
            transform="translate(462.000000, 127.000000)"
            fill="#000000"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="20"
            fontWeight="normal"
          >
            <g id="Group-14">
              <text id="Vendredi">
                <tspan x="685.063415" y="19">
                  Vendredi
                </tspan>
              </text>
              <text id="Jeudi">
                <tspan x="523.454878" y="19">
                  Jeudi
                </tspan>
              </text>
              <text id="Mercredi">
                <tspan x="369.031707" y="19">
                  Mercredi
                </tspan>
              </text>
              <text id="Mardi">
                <tspan x="174.608537" y="19">
                  Mardi
                </tspan>
              </text>
              <text id="Lundi">
                <tspan x="0" y="19">
                  Lundi
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-6" transform="translate(100.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="148"
              height="49"
              rx="10"
            />
            <text
              id="2021/2022"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                2021/2022
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(114.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy" transform="translate(259.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="Plan-de-cours"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                Plan de cours
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy-2" transform="translate(441.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="5H-B"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                5H B
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="full-time-table" transform="translate(394.000000, 159.000000)">
            <g id="timeslot" transform="translate(716.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-15" transform="translate(393.500000, 120.478002)">
            <g id="Group-14-Copy-3" transform="translate(716.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Vendredi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="50.3714558" y="26">
                  Vendredi
                </tspan>
              </text>
            </g>
            <g id="Group-14-Copy-2" transform="translate(537.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Jeudi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="65.234737" y="26">
                  Jeudi
                </tspan>
              </text>
            </g>
            <g id="Group-14-Copy" transform="translate(358.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Mercredi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="50.4202839" y="26">
                  Mercredi
                </tspan>
              </text>
            </g>
            <g id="Group-14" transform="translate(179.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Mardi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="64.1019245" y="26">
                  Mardi
                </tspan>
              </text>
            </g>
            <g id="Group-14">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Lundi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="65.366573" y="26">
                  Lundi
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group" transform="translate(26.000000, 269.000000)">
            <g id="Group-6" transform="translate(0.000000, 27.000000)">
              <rect
                id="Rectangle"
                stroke="#999999"
                fill="#FFFFFF"
                x="0.5"
                y="0.5"
                width="261"
                height="49"
                rx="10"
              />
              <text
                id="Toutes-les-matières"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="16"
                fontWeight="400"
                fill="#000000"
              >
                <tspan x="16" y="30">
                  Toutes les matières
                </tspan>
              </text>
              <g
                id="SL/icons/icon/arrow-short"
                transform="translate(229.753170, 21.246883)"
                fill="#101010"
              >
                <path
                  d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                  id="Path"
                  transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
                />
              </g>
            </g>
            <text
              id="Matière"
              opacity="0.65"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="14"
              fontWeight="normal"
              fill="#000000"
            >
              <tspan x="0" y="13">
                Matière
              </tspan>
            </text>
            <rect
              id="Rectangle"
              fill="#F59C05"
              x="0"
              y="88"
              width="262"
              height="43"
              rx="5"
            />
            <text
              id="Ajouter-une-entrée"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#FFFFFF"
            >
              <tspan x="70.328125" y="115">
                Ajouter une entrée
              </tspan>
            </text>
            <g
              id="SL/icons/naked-icon"
              transform="translate(20.537273, 100.633333)"
              fill="#FFFFFF"
            >
              <g
                id="iconfinder_add_134224"
                transform="translate(-0.000000, 0.000000)"
              >
                <path
                  d="M17.1527778,7.6 L10.5555556,7.6 L10.5555556,1.26666667 C10.5555556,0.567466667 9.96444444,0 9.23611111,0 C8.50777778,0 7.91666667,0.567466667 7.91666667,1.26666667 L7.91666667,7.6 L1.31944444,7.6 C0.591111111,7.6 0,8.16746667 0,8.86666667 C0,9.56586667 0.591111111,10.1333333 1.31944444,10.1333333 L7.91666667,10.1333333 L7.91666667,16.4666667 C7.91666667,17.1658667 8.50777778,17.7333333 9.23611111,17.7333333 C9.96444444,17.7333333 10.5555556,17.1658667 10.5555556,16.4666667 L10.5555556,10.1333333 L17.1527778,10.1333333 C17.8811111,10.1333333 18.4722222,9.56586667 18.4722222,8.86666667 C18.4722222,8.16746667 17.8811111,7.6 17.1527778,7.6 Z"
                  id="Path"
                />
              </g>
            </g>
          </g>
          <g
            id="mobile/btn/primary/default"
            transform="translate(1117.000000, 16.000000)"
          >
            <rect
              id="Rectangle"
              fill="#005D9F"
              x="0"
              y="0"
              width="172"
              height="50"
              rx="10"
            />
            <text
              id="Primary"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#FFFFFF"
            >
              <tspan x="36.8828125" y="31">
                Nouveau plan
              </tspan>
            </text>
          </g>
          <line
            x1="722.5"
            y1="517.5"
            x2="722.5"
            y2="565.5"
            id="Line-5"
            stroke="#979797"
            strokeLinecap="square"
          />
          <line
            x1="740.5"
            y1="542.5"
            x2="722.5"
            y2="542.5"
            id="Line-5"
            stroke="#979797"
            strokeLinecap="square"
          />
          <g id="Group-20" transform="translate(24.000000, 121.000000)">
            <text
              id="Plan"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#000000"
            >
              <tspan x="13.9492188" y="15">
                Plan
              </tspan>
            </text>
            <g id="Group-19" transform="translate(0.000000, 35.000000)">
              <line
                x1="0.5"
                y1="0.5"
                x2="0.5"
                y2="50.5"
                id="Line-4"
                stroke="#ECE9E9"
                strokeLinecap="square"
              />
              <g id="Group-14" transform="translate(0.000000, 2.000000)">
                <line
                  x1="0.5"
                  y1="0.5"
                  x2="0.5"
                  y2="16.5"
                  id="Line-4"
                  stroke="#005D9F"
                  strokeWidth="2"
                  strokeLinecap="square"
                />
                <text
                  id="Import-/-Export"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#8C8C8C"
                >
                  <tspan x="15" y="44">
                    Import / Export
                  </tspan>
                </text>
                <text
                  id="Paramètres-Copy"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#8C8C8C"
                >
                  <tspan x="15" y="78">
                    Paramètres
                  </tspan>
                </text>
              </g>
              <text
                id="Plan-de-cours"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="14"
                fontWeight="bold"
                fill="#005D9F"
              >
                <tspan x="15" y="15">
                  Plan de cours
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-9" transform="translate(352.000000, 158.000000)">
            <g id="Group-Copy-7" transform="translate(0.000000, 681.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="9"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  9
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-6" transform="translate(0.000000, 596.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="8"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  8
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-5" transform="translate(0.000000, 511.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="7"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  7
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-4" transform="translate(0.000000, 426.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="6"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  6
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-3" transform="translate(0.000000, 340.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="5"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  5
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-2" transform="translate(0.000000, 255.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="4"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  4
                </tspan>
              </text>
            </g>
            <g id="Group-Copy" transform="translate(0.000000, 170.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="3"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  3
                </tspan>
              </text>
            </g>
            <g id="Group" transform="translate(0.000000, 85.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="2"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  2
                </tspan>
              </text>
            </g>
            <g id="Group">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="1"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  1
                </tspan>
              </text>
            </g>
          </g>
          <rect
            id="Rectangle"
            fill="#101010"
            opacity="0.3"
            x="-91"
            y="1"
            width="1441"
            height="961"
          />
          <rect
            id="Rectangle"
            fill="#FFFFFF"
            x="487"
            y="236"
            width="285"
            height="428"
            rx="9"
          />
          <g id="Group-7" transform="translate(516.000000, 262.000000)">
            <text
              id="Ajouter-une-entrée"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              line-spacing="22"
              fill="#000000"
            >
              <tspan x="0" y="15">
                Ajouter une entrée
              </tspan>
            </text>
            <g id="Group-3" transform="translate(0.000000, 52.000000)">
              <g id="Group" transform="translate(0.500000, 24.000000)">
                <rect
                  id="Rectangle"
                  stroke="#999999"
                  fill="#FFFFFF"
                  x="0.5"
                  y="0.5"
                  width="225"
                  height="49"
                  rx="10"
                />
                <g
                  id="SL/icons/icon/arrow"
                  transform="translate(190.174321, 19.112719)"
                  fill="#101010"
                >
                  <path
                    d="M14.2006313,15.2830797 C13.914572,15.2847507 13.6396242,15.1700403 13.4365235,14.9642695 L4.82685776,6.17001141 C4.62311793,5.96360292 4.50851717,5.68263092 4.50851717,5.38952101 C4.50851717,5.0964111 4.62311793,4.8154391 4.82685776,4.60903061 L13.4365235,-4.18522746 C13.8585286,-4.61628041 14.542734,-4.61628041 14.9647391,-4.18522746 C15.3867443,-3.75417452 15.3867443,-3.0552996 14.9647391,-2.62424666 L7.10841918,5.38952101 L14.9647391,13.4032887 C15.168479,13.6096972 15.2830797,13.8906692 15.2830797,14.1837791 C15.2830797,14.476889 15.168479,14.757861 14.9647391,14.9642695 C14.7616384,15.1700403 14.4866907,15.2847507 14.2006313,15.2830797 Z"
                    id="Path"
                    transform="translate(9.895798, 5.387281) scale(1, -1) rotate(90.000000) translate(-9.895798, -5.387281) "
                  />
                </g>
                <text
                  id="Français"
                  fontFamily="Roboto-Medium, Roboto"
                  fontSize="16"
                  fontWeight="400"
                  fill="#000000"
                >
                  <tspan x="16" y="30">
                    Français
                  </tspan>
                </text>
              </g>
              <text
                id="Matière"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="0" y="13">
                  Matière
                </tspan>
              </text>
            </g>
            <g id="Group-3-Copy" transform="translate(0.000000, 141.000000)">
              <g id="Group" transform="translate(0.500000, 24.000000)">
                <rect
                  id="Rectangle"
                  stroke="#999999"
                  fill="#FFFFFF"
                  x="0.5"
                  y="0.5"
                  width="225"
                  height="49"
                  rx="10"
                />
                <g
                  id="SL/icons/icon/arrow"
                  transform="translate(190.174321, 19.112719)"
                  fill="#101010"
                >
                  <path
                    d="M14.2006313,15.2830797 C13.914572,15.2847507 13.6396242,15.1700403 13.4365235,14.9642695 L4.82685776,6.17001141 C4.62311793,5.96360292 4.50851717,5.68263092 4.50851717,5.38952101 C4.50851717,5.0964111 4.62311793,4.8154391 4.82685776,4.60903061 L13.4365235,-4.18522746 C13.8585286,-4.61628041 14.542734,-4.61628041 14.9647391,-4.18522746 C15.3867443,-3.75417452 15.3867443,-3.0552996 14.9647391,-2.62424666 L7.10841918,5.38952101 L14.9647391,13.4032887 C15.168479,13.6096972 15.2830797,13.8906692 15.2830797,14.1837791 C15.2830797,14.476889 15.168479,14.757861 14.9647391,14.9642695 C14.7616384,15.1700403 14.4866907,15.2847507 14.2006313,15.2830797 Z"
                    id="Path"
                    transform="translate(9.895798, 5.387281) scale(1, -1) rotate(90.000000) translate(-9.895798, -5.387281) "
                  />
                </g>
                <text
                  id="Michael-Dayen"
                  fontFamily="Roboto-Medium, Roboto"
                  fontSize="16"
                  fontWeight="400"
                  fill="#000000"
                >
                  <tspan x="16" y="30">
                    Michael Dayen
                  </tspan>
                </text>
              </g>
              <text
                id="Professeur"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="0" y="13">
                  Professeur
                </tspan>
              </text>
            </g>
            <g id="Group-3-Copy" transform="translate(0.000000, 230.000000)">
              <g id="Group" transform="translate(0.500000, 24.000000)">
                <rect
                  id="Rectangle"
                  stroke="#999999"
                  fill="#FFFFFF"
                  x="0.5"
                  y="0.5"
                  width="225"
                  height="49"
                  rx="10"
                />
                <g
                  id="SL/icons/icon/arrow"
                  transform="translate(211.554064, 35.948130)"
                  fill="#101010"
                >
                  <path
                    d="M6.72661483,7.23935356 C6.59111303,7.24014505 6.46087464,7.18580856 6.36466902,7.08833818 L2.28640631,2.92263699 C2.18989797,2.82486454 2.1356134,2.69177254 2.1356134,2.552931 C2.1356134,2.41408947 2.18989797,2.28099747 2.28640631,2.18322502 L6.36466902,-1.98247617 C6.56456617,-2.18665914 6.8886635,-2.18665914 7.08856065,-1.98247617 C7.2884578,-1.77829319 7.2884578,-1.44724718 7.08856065,-1.24306421 L3.36714593,2.552931 L7.08856065,6.34892621 C7.18506899,6.44669866 7.23935356,6.57979066 7.23935356,6.7186322 C7.23935356,6.85747373 7.18506899,6.99056573 7.08856065,7.08833818 C6.99235503,7.18580856 6.86211663,7.24014505 6.72661483,7.23935356 Z"
                    id="Path"
                    transform="translate(4.687483, 2.551870) scale(1, -1) rotate(90.000000) translate(-4.687483, -2.551870) "
                  />
                </g>
                <g
                  id="SL/icons/icon/arrow"
                  transform="translate(216.241548, 15.500000) scale(1, -1) translate(-216.241548, -15.500000) translate(211.554064, 12.948130)"
                  fill="#101010"
                >
                  <path
                    d="M6.72661483,7.23935356 C6.59111303,7.24014505 6.46087464,7.18580856 6.36466902,7.08833818 L2.28640631,2.92263699 C2.18989797,2.82486454 2.1356134,2.69177254 2.1356134,2.552931 C2.1356134,2.41408947 2.18989797,2.28099747 2.28640631,2.18322502 L6.36466902,-1.98247617 C6.56456617,-2.18665914 6.8886635,-2.18665914 7.08856065,-1.98247617 C7.2884578,-1.77829319 7.2884578,-1.44724718 7.08856065,-1.24306421 L3.36714593,2.552931 L7.08856065,6.34892621 C7.18506899,6.44669866 7.23935356,6.57979066 7.23935356,6.7186322 C7.23935356,6.85747373 7.18506899,6.99056573 7.08856065,7.08833818 C6.99235503,7.18580856 6.86211663,7.24014505 6.72661483,7.23935356 Z"
                    id="Path"
                    transform="translate(4.687483, 2.551870) scale(1, -1) rotate(90.000000) translate(-4.687483, -2.551870) "
                  />
                </g>
                <text
                  id="5"
                  fontFamily="Roboto-Medium, Roboto"
                  fontSize="16"
                  fontWeight="400"
                  fill="#000000"
                >
                  <tspan x="16" y="30">
                    5
                  </tspan>
                </text>
              </g>
              <text
                id="Nombre-de-périodes-h"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="0" y="13">
                  Nombre de périodes hebdomadaires
                </tspan>
              </text>
            </g>
            <g id="Group-5" transform="translate(0.000000, 334.000000)">
              <g id="Group-4">
                <rect
                  id="Ajouter-Rectangle"
                  onClick={nextStep}
                  className="clickable-svg-part"
                  fill="#F59C05"
                  x="0"
                  y="0"
                  width="108"
                  height="43"
                  rx="5"
                />
                <text
                  id="Ajouter"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  fill="#FFFFFF"
                >
                  <tspan x="24.59375" y="27">
                    Ajouter
                  </tspan>
                </text>
              </g>
              <rect
                id="Annuler-Rectangle"
                onClick={plan01StepCallback}
                className="clickable-svg-part"
                stroke="#999999"
                fill="#FFFFFF"
                x="116.5"
                y="0.5"
                width="107"
                height="42"
                rx="5"
              />
              <text
                id="Annuler"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="16"
                fontWeight="bold"
                fill="#000000"
              >
                <tspan x="142.003906" y="27">
                  Annuler
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
    ),
    [nextStep, plan01StepCallback],
  );
  const step03 = useMemo(
    () => (
      <svg
        width="1349px"
        height="962px"
        viewBox="0 0 1349 962"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-1"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-2" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-4"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-5" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-7"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-8" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-10"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-11" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-13"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-14" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-16"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-17" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-19"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-20" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-22"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-23" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-25"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-26" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-28"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-29" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-31"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-32" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-34"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-35" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-37"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-38" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-40"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-41" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-43"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-44" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-46"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-47" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-49"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-50" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-52"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-53" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-55"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-56" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-58"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-59" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-61"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-62" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-64"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-65" x="0" y="0" width="164" height="76" />
          <filter
            x="-8.2%"
            y="-17.8%"
            width="116.5%"
            height="135.5%"
            filterUnits="objectBoundingBox"
            id="filter-67"
          >
            <feOffset
              dx="3"
              dy="2"
              in="SourceAlpha"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation="2"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.501358696   0 0 0 0 0.501358696   0 0 0 0 0.501358696  0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <rect id="path-68" x="0" y="0" width="164" height="76" />
        </defs>
        <g
          id="SL/desktop/Admin/plan(Empty)"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect fill="#F1F3F9" x="0" y="0" width="1349" height="962" />
          <g
            id="Group-2"
            transform="translate(22.000000, 29.000000)"
            fill="#000000"
            fontFamily="Roboto-Medium, Roboto"
            fontSize="20"
            fontWeight="400"
          >
            <text id="Plans">
              <tspan x="0" y="19">
                Plans
              </tspan>
            </text>
          </g>
          <line
            x1="351.5"
            y1="158.5"
            x2="351.5"
            y2="923.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="350.5"
            y1="78.5"
            x2="0.5"
            y2="78.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <g
            id="Group-9"
            transform="translate(368.000000, 186.000000)"
            fill="#000000"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fontWeight="normal"
          >
            <text id="1">
              <tspan x="0" y="13">
                1
              </tspan>
            </text>
            <text id="2">
              <tspan x="0" y="99">
                2
              </tspan>
            </text>
            <text id="3">
              <tspan x="0" y="185">
                3
              </tspan>
            </text>
            <text id="4">
              <tspan x="0" y="271">
                4
              </tspan>
            </text>
            <text id="5">
              <tspan x="0" y="357">
                5
              </tspan>
            </text>
            <text id="6">
              <tspan x="0" y="443">
                6
              </tspan>
            </text>
            <text id="7">
              <tspan x="0" y="529">
                7
              </tspan>
            </text>
            <text id="8">
              <tspan x="0" y="615">
                8
              </tspan>
            </text>
            <text id="9">
              <tspan x="0" y="701">
                9
              </tspan>
            </text>
          </g>
          <line
            x1="393.5"
            y1="120.5"
            x2="393.5"
            y2="923.52497"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.465966"
            y1="158.5"
            x2="1281.53403"
            y2="158.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="393.5"
            y1="120.5"
            x2="1281.53403"
            y2="120.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.5"
            y1="78.5"
            x2="1349.5"
            y2="78.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <g
            id="Group-15"
            transform="translate(462.000000, 127.000000)"
            fill="#000000"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="20"
            fontWeight="normal"
          >
            <g id="Group-14">
              <text id="Vendredi">
                <tspan x="685.063415" y="19">
                  Vendredi
                </tspan>
              </text>
              <text id="Jeudi">
                <tspan x="523.454878" y="19">
                  Jeudi
                </tspan>
              </text>
              <text id="Mercredi">
                <tspan x="369.031707" y="19">
                  Mercredi
                </tspan>
              </text>
              <text id="Mardi">
                <tspan x="174.608537" y="19">
                  Mardi
                </tspan>
              </text>
              <text id="Lundi">
                <tspan x="0" y="19">
                  Lundi
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-6" transform="translate(100.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="148"
              height="49"
              rx="10"
            />
            <text
              id="2021/2022"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                2021/2022
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(114.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy" transform="translate(259.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="Plan-de-cours"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                Plan de cours
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy-2" transform="translate(441.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="5H-B"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                5H B
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6" transform="translate(26.000000, 296.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="261"
              height="49"
              rx="10"
            />
            <text
              id="Toutes-les-matières"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                Toutes les matières
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(229.753170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <text
            id="Matière"
            opacity="0.65"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fontWeight="normal"
            fill="#000000"
          >
            <tspan x="26" y="282">
              Matière
            </tspan>
          </text>
          <rect
            id="Rectangle"
            fill="#F59C05"
            x="26"
            y="357"
            width="262"
            height="43"
            rx="5"
          />
          <text
            id="Ajouter-une-entrée"
            fontFamily="Roboto-Bold, Roboto"
            fontSize="16"
            fontWeight="bold"
            fill="#FFFFFF"
          >
            <tspan x="96.328125" y="385">
              Ajouter une entrée
            </tspan>
          </text>
          <g
            id="SL/icons/naked-icon"
            transform="translate(46.537273, 370.633333)"
            fill="#FFFFFF"
          >
            <g
              id="iconfinder_add_134224"
              transform="translate(-0.000000, 0.000000)"
            >
              <path
                d="M17.1527778,7.6 L10.5555556,7.6 L10.5555556,1.26666667 C10.5555556,0.567466667 9.96444444,0 9.23611111,0 C8.50777778,0 7.91666667,0.567466667 7.91666667,1.26666667 L7.91666667,7.6 L1.31944444,7.6 C0.591111111,7.6 0,8.16746667 0,8.86666667 C0,9.56586667 0.591111111,10.1333333 1.31944444,10.1333333 L7.91666667,10.1333333 L7.91666667,16.4666667 C7.91666667,17.1658667 8.50777778,17.7333333 9.23611111,17.7333333 C9.96444444,17.7333333 10.5555556,17.1658667 10.5555556,16.4666667 L10.5555556,10.1333333 L17.1527778,10.1333333 C17.8811111,10.1333333 18.4722222,9.56586667 18.4722222,8.86666667 C18.4722222,8.16746667 17.8811111,7.6 17.1527778,7.6 Z"
                id="Path"
              />
            </g>
          </g>
          <g id="full-time-table" transform="translate(394.000000, 159.000000)">
            <g id="timeslot" transform="translate(716.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 255.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 170.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 85.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-15" transform="translate(393.500000, 120.478002)">
            <g id="Group-14-Copy-3" transform="translate(716.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Vendredi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="50.3714558" y="26">
                  Vendredi
                </tspan>
              </text>
            </g>
            <g id="Group-14-Copy-2" transform="translate(537.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Jeudi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="65.234737" y="26">
                  Jeudi
                </tspan>
              </text>
            </g>
            <g id="Group-14-Copy" transform="translate(358.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Mercredi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="50.4202839" y="26">
                  Mercredi
                </tspan>
              </text>
            </g>
            <g id="Group-14" transform="translate(179.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Mardi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="64.1019245" y="26">
                  Mardi
                </tspan>
              </text>
            </g>
            <g id="Group-14">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Lundi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="65.366573" y="26">
                  Lundi
                </tspan>
              </text>
            </g>
          </g>
          <g
            id="Group-Course-01"
            onClick={nextStep}
            className="clickable-svg-part"
            transform="translate(26.000000, 415.000000)"
          >
            <g
              id="plan/timeslot/fr"
              filter="url(#filter-1)"
              transform="translate(128.000000, 16.000000)"
            >
              <g id="Group-19">
                <mask id="mask-3" fill="white">
                  <use xlinkHref="#path-2" />
                </mask>
                <use id="Rectangle" fill="#B620E0" xlinkHref="#path-2" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-3)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-3)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-3)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-3)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Français
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr"
              filter="url(#filter-4)"
              transform="translate(96.000000, 11.000000)"
            >
              <g id="Group-19">
                <mask id="mask-6" fill="white">
                  <use xlinkHref="#path-5" />
                </mask>
                <use id="Rectangle" fill="#B620E0" xlinkHref="#path-5" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-6)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-6)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-6)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-6)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Français
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy"
              filter="url(#filter-7)"
              transform="translate(64.000000, 7.000000)"
            >
              <g id="Group-19">
                <mask id="mask-9" fill="white">
                  <use xlinkHref="#path-8" />
                </mask>
                <use id="Rectangle" fill="#B620E0" xlinkHref="#path-8" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-9)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-9)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-9)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-9)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Français
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy-2"
              filter="url(#filter-10)"
              transform="translate(32.000000, 4.000000)"
            >
              <g id="Group-19">
                <mask id="mask-12" fill="white">
                  <use xlinkHref="#path-11" />
                </mask>
                <use id="Rectangle" fill="#B620E0" xlinkHref="#path-11" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-12)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-12)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-12)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-12)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Français
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g id="plan/timeslot/fr-copy-3" filter="url(#filter-13)">
              <g id="Group-19">
                <mask id="mask-15" fill="white">
                  <use xlinkHref="#path-14" />
                </mask>
                <use id="Rectangle" fill="#B620E0" xlinkHref="#path-14" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-15)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-15)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-15)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-15)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Français
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group-Course-02"
            onClick={nextStep}
            className="clickable-svg-part"
            transform="translate(26.000000, 517.000000)"
          >
            <g
              id="plan/timeslot/fr"
              filter="url(#filter-16)"
              transform="translate(96.000000, 11.000000)"
            >
              <g id="Group-19">
                <mask id="mask-18" fill="white">
                  <use xlinkHref="#path-17" />
                </mask>
                <use id="Rectangle" fill="#F7B500" xlinkHref="#path-17" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-18)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-18)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-18)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-18)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Math
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy"
              filter="url(#filter-19)"
              transform="translate(64.000000, 7.000000)"
            >
              <g id="Group-19">
                <mask id="mask-21" fill="white">
                  <use xlinkHref="#path-20" />
                </mask>
                <use id="Rectangle" fill="#F7B500" xlinkHref="#path-20" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-21)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-21)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-21)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-21)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Math
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy-2"
              filter="url(#filter-22)"
              transform="translate(32.000000, 4.000000)"
            >
              <g id="Group-19">
                <mask id="mask-24" fill="white">
                  <use xlinkHref="#path-23" />
                </mask>
                <use id="Rectangle" fill="#F7B500" xlinkHref="#path-23" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-24)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-24)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-24)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-24)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Math
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g id="plan/timeslot/fr-copy-3" filter="url(#filter-25)">
              <g id="Group-19">
                <mask id="mask-27" fill="white">
                  <use xlinkHref="#path-26" />
                </mask>
                <use id="Rectangle" fill="#F7B500" xlinkHref="#path-26" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-27)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-27)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-27)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-27)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Math
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group-Course-03"
            onClick={nextStep}
            className="clickable-svg-part"
            transform="translate(28.000000, 619.000000)"
          >
            <g
              id="plan/timeslot/fr"
              filter="url(#filter-28)"
              transform="translate(96.000000, 11.000000)"
            >
              <g id="Group-19">
                <mask id="mask-30" fill="white">
                  <use xlinkHref="#path-29" />
                </mask>
                <use id="Rectangle" fill="#6236FF" xlinkHref="#path-29" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-30)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-30)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-30)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-30)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Allemand
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy"
              filter="url(#filter-31)"
              transform="translate(64.000000, 7.000000)"
            >
              <g id="Group-19">
                <mask id="mask-33" fill="white">
                  <use xlinkHref="#path-32" />
                </mask>
                <use id="Rectangle" fill="#6236FF" xlinkHref="#path-32" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-33)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-33)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-33)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-33)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Allemand
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy-2"
              filter="url(#filter-34)"
              transform="translate(32.000000, 4.000000)"
            >
              <g id="Group-19">
                <mask id="mask-36" fill="white">
                  <use xlinkHref="#path-35" />
                </mask>
                <use id="Rectangle" fill="#6236FF" xlinkHref="#path-35" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-36)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-36)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-36)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-36)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Allemand
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g id="plan/timeslot/fr-copy-3" filter="url(#filter-37)">
              <g id="Group-19">
                <mask id="mask-39" fill="white">
                  <use xlinkHref="#path-38" />
                </mask>
                <use id="Rectangle" fill="#6236FF" xlinkHref="#path-38" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-39)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-39)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-39)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-39)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Allemand
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group-Course-04"
            onClick={nextStep}
            className="clickable-svg-part"
            transform="translate(26.000000, 721.000000)"
          >
            <g
              id="plan/timeslot/fr"
              filter="url(#filter-40)"
              transform="translate(96.000000, 11.000000)"
            >
              <g id="Group-19">
                <mask id="mask-42" fill="white">
                  <use xlinkHref="#path-41" />
                </mask>
                <use id="Rectangle" fill="#87B1CF" xlinkHref="#path-41" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-42)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-42)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-42)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-42)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Anglais
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy"
              filter="url(#filter-43)"
              transform="translate(64.000000, 7.000000)"
            >
              <g id="Group-19">
                <mask id="mask-45" fill="white">
                  <use xlinkHref="#path-44" />
                </mask>
                <use id="Rectangle" fill="#87B1CF" xlinkHref="#path-44" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-45)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-45)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-45)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-45)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Anglais
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy-2"
              filter="url(#filter-46)"
              transform="translate(32.000000, 4.000000)"
            >
              <g id="Group-19">
                <mask id="mask-48" fill="white">
                  <use xlinkHref="#path-47" />
                </mask>
                <use id="Rectangle" fill="#87B1CF" xlinkHref="#path-47" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-48)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-48)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-48)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-48)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Anglais
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g id="plan/timeslot/fr-copy-3" filter="url(#filter-49)">
              <g id="Group-19">
                <mask id="mask-51" fill="white">
                  <use xlinkHref="#path-50" />
                </mask>
                <use id="Rectangle" fill="#87B1CF" xlinkHref="#path-50" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-51)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-51)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-51)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-51)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Anglais
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group-Course-05"
            onClick={nextStep}
            className="clickable-svg-part"
            transform="translate(26.000000, 823.000000)"
          >
            <g
              id="plan/timeslot/fr-copy"
              filter="url(#filter-52)"
              transform="translate(64.000000, 7.000000)"
            >
              <g id="Group-19">
                <mask id="mask-54" fill="white">
                  <use xlinkHref="#path-53" />
                </mask>
                <use id="Rectangle" fill="#E02020" xlinkHref="#path-53" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-54)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-54)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-54)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-54)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        ACM
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy-2"
              filter="url(#filter-55)"
              transform="translate(32.000000, 4.000000)"
            >
              <g id="Group-19">
                <mask id="mask-57" fill="white">
                  <use xlinkHref="#path-56" />
                </mask>
                <use id="Rectangle" fill="#E02020" xlinkHref="#path-56" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-57)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-57)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-57)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-57)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        ACM
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g id="plan/timeslot/fr-copy-3" filter="url(#filter-58)">
              <g id="Group-19">
                <mask id="mask-60" fill="white">
                  <use xlinkHref="#path-59" />
                </mask>
                <use id="Rectangle" fill="#E02020" xlinkHref="#path-59" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-60)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-60)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    005
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-60)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-60)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        ACM
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group-Course-06"
            onClick={nextStep}
            className="clickable-svg-part"
            transform="translate(26.000000, 921.000000)"
          >
            <g
              id="plan/timeslot/fr-copy"
              filter="url(#filter-61)"
              transform="translate(64.000000, 7.000000)"
            >
              <g id="Group-19">
                <mask id="mask-63" fill="white">
                  <use xlinkHref="#path-62" />
                </mask>
                <use id="Rectangle" fill="#44D7B6" xlinkHref="#path-62" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-63)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-63)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-63)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-63)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        ACM
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g
              id="plan/timeslot/fr-copy-2"
              filter="url(#filter-64)"
              transform="translate(32.000000, 4.000000)"
            >
              <g id="Group-19">
                <mask id="mask-66" fill="white">
                  <use xlinkHref="#path-65" />
                </mask>
                <use id="Rectangle" fill="#44D7B6" xlinkHref="#path-65" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-66)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-66)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    203
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-66)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-66)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        ACM
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
            <g id="plan/timeslot/fr-copy-3" filter="url(#filter-67)">
              <g id="Group-19">
                <mask id="mask-69" fill="white">
                  <use xlinkHref="#path-68" />
                </mask>
                <use id="Rectangle" fill="#44D7B6" xlinkHref="#path-68" />
                <rect
                  id="Rectangle"
                  fill="#FFFFFF"
                  opacity="0.657163318"
                  mask="url(#mask-69)"
                  x="0"
                  y="0"
                  width="164"
                  height="76"
                />
                <text
                  id="203"
                  mask="url(#mask-69)"
                  fontFamily="Roboto-Italic, Roboto"
                  fontSize="14"
                  font-style="italic"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="15" y="66">
                    005
                  </tspan>
                </text>
                <text
                  id="MD"
                  mask="url(#mask-69)"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#000000"
                >
                  <tspan x="133" y="66">
                    MD
                  </tspan>
                </text>
                <g
                  id="Group"
                  mask="url(#mask-69)"
                  fontFamily="Roboto-Bold, Roboto"
                  fontSize="16"
                  fontWeight="bold"
                  line-spacing="22"
                >
                  <g
                    transform="translate(14.733766, 6.000000)"
                    id="Group-3"
                    fill="#000000"
                  >
                    <text id="Géographie">
                      <tspan x="0" y="15">
                        Biologie
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                id="SL/icons/naked-icon"
                transform="translate(142.117647, 9.000000)"
                fill="#101010"
                fillRule="nonzero"
              >
                <g id="2849830_multimedia_options_setting_settings_gear_icon">
                  <path
                    d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                    id="Shape"
                  />
                  <path
                    d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="mobile/btn/primary/default"
            transform="translate(1117.000000, 16.000000)"
          >
            <rect
              id="Rectangle"
              fill="#005D9F"
              x="0"
              y="0"
              width="172"
              height="50"
              rx="10"
            />
            <text
              id="Primary"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#FFFFFF"
            >
              <tspan x="36.8828125" y="31">
                Nouveau plan
              </tspan>
            </text>
          </g>
          <g id="Group-20" transform="translate(24.000000, 121.000000)">
            <text
              id="Plan"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#000000"
            >
              <tspan x="13.9492188" y="15">
                Plan
              </tspan>
            </text>
            <g id="Group-19" transform="translate(0.000000, 35.000000)">
              <line
                x1="0.5"
                y1="0.5"
                x2="0.5"
                y2="50.5"
                id="Line-4"
                stroke="#ECE9E9"
                strokeLinecap="square"
              />
              <g id="Group-14" transform="translate(0.000000, 2.000000)">
                <line
                  x1="0.5"
                  y1="0.5"
                  x2="0.5"
                  y2="16.5"
                  id="Line-4"
                  stroke="#005D9F"
                  strokeWidth="2"
                  strokeLinecap="square"
                />
                <text
                  id="Import-/-Export"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#8C8C8C"
                >
                  <tspan x="15" y="44">
                    Import / Export
                  </tspan>
                </text>
                <text
                  id="Paramètres-Copy-03"
                  onClick={planSettings05StepCallback}
                  className="clickable-svg-part"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#8C8C8C"
                >
                  <tspan x="15" y="78">
                    Paramètres
                  </tspan>
                </text>
              </g>
              <text
                id="Plan-de-cours"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="14"
                fontWeight="bold"
                fill="#005D9F"
              >
                <tspan x="15" y="15">
                  Plan de cours
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-9" transform="translate(352.000000, 158.000000)">
            <g id="Group-Copy-7" transform="translate(0.000000, 681.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="9"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  9
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-6" transform="translate(0.000000, 596.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="8"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  8
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-5" transform="translate(0.000000, 511.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="7"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  7
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-4" transform="translate(0.000000, 426.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="6"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  6
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-3" transform="translate(0.000000, 340.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="5"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  5
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-2" transform="translate(0.000000, 255.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="4"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  4
                </tspan>
              </text>
            </g>
            <g id="Group-Copy" transform="translate(0.000000, 170.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="3"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  3
                </tspan>
              </text>
            </g>
            <g id="Group" transform="translate(0.000000, 85.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="2"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  2
                </tspan>
              </text>
            </g>
            <g id="Group">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="1"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  1
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
    ),
    [nextStep, plan01StepCallback],
  );
  const step04 = useMemo(
    () => (
      <svg
        width="1349px"
        height="961px"
        viewBox="0 0 1349 961"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <rect id="path-1" x="0" y="0" width="164" height="76" />
          <rect id="path-3" x="0" y="0" width="164" height="76" />
          <rect id="path-5" x="0" y="0" width="164" height="76" />
          <rect id="path-7" x="0" y="0" width="164" height="76" />
          <rect id="path-9" x="0" y="0" width="164" height="76" />
          <rect id="path-11" x="0" y="0" width="164" height="76" />
          <rect id="path-13" x="0" y="0" width="164" height="76" />
          <rect id="path-15" x="0" y="0" width="164" height="76" />
          <rect id="path-17" x="0" y="0" width="164" height="76" />
          <rect id="path-19" x="0" y="0" width="164" height="76" />
          <rect id="path-21" x="0" y="0" width="164" height="76" />
          <rect id="path-23" x="0" y="0" width="164" height="76" />
          <rect id="path-25" x="0" y="0" width="164" height="76" />
          <rect id="path-27" x="0" y="0" width="164" height="76" />
          <rect id="path-29" x="0" y="0" width="164" height="76" />
          <rect id="path-31" x="0" y="0" width="164" height="76" />
          <rect id="path-33" x="0" y="0" width="164" height="76" />
          <rect id="path-35" x="0" y="0" width="164" height="76" />
          <rect id="path-37" x="0" y="0" width="164" height="76" />
          <rect id="path-39" x="0" y="0" width="164" height="76" />
          <rect id="path-41" x="0" y="0" width="164" height="76" />
          <rect id="path-43" x="0" y="0" width="164" height="76" />
          <rect id="path-45" x="0" y="0" width="164" height="76" />
          <rect id="path-47" x="0" y="0" width="164" height="76" />
          <rect id="path-49" x="0" y="0" width="164" height="76" />
          <rect id="path-51" x="0" y="0" width="164" height="76" />
          <rect id="path-53" x="0" y="0" width="164" height="76" />
          <rect id="path-55" x="0" y="0" width="164" height="76" />
          <rect id="path-57" x="0" y="0" width="164" height="76" />
          <rect id="path-59" x="0" y="0" width="164" height="76" />
          <rect id="path-61" x="0" y="0" width="164" height="76" />
          <rect id="path-63" x="0" y="0" width="164" height="76" />
        </defs>
        <g
          id="step04"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect fill="#F1F3F9" x="0" y="0" width="1349" height="961" />
          <g
            id="Group-2"
            transform="translate(22.000000, 28.000000)"
            fill="#000000"
            fontFamily="Roboto-Medium, Roboto"
            fontSize="20"
            fontWeight="400"
          >
            <text id="Plans">
              <tspan x="0" y="19">
                Plans
              </tspan>
            </text>
          </g>
          <line
            x1="351.5"
            y1="157.5"
            x2="351.5"
            y2="922.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="350.5"
            y1="77.5"
            x2="0.5"
            y2="77.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <g id="Group-9" transform="translate(352.000000, 158.000000)">
            <g id="Group-Copy-7" transform="translate(0.000000, 681.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="9"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  9
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-6" transform="translate(0.000000, 596.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="8"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  8
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-5" transform="translate(0.000000, 511.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="7"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  7
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-4" transform="translate(0.000000, 426.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="6"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  6
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-3" transform="translate(0.000000, 340.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="5"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  5
                </tspan>
              </text>
            </g>
            <g id="Group-Copy-2" transform="translate(0.000000, 255.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="4"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  4
                </tspan>
              </text>
            </g>
            <g id="Group-Copy" transform="translate(0.000000, 170.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="3"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  3
                </tspan>
              </text>
            </g>
            <g id="Group" transform="translate(0.000000, 85.000000)">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="2"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  2
                </tspan>
              </text>
            </g>
            <g id="Group">
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="43"
                height="84"
              />
              <text
                id="1"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="16"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="17" y="47.4827586">
                  1
                </tspan>
              </text>
            </g>
          </g>
          <line
            x1="393.5"
            y1="119.5"
            x2="393.5"
            y2="922.52497"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.465966"
            y1="157.5"
            x2="1281.53403"
            y2="157.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="393.5"
            y1="119.5"
            x2="1281.53403"
            y2="119.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.5"
            y1="77.5"
            x2="1349.5"
            y2="77.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <g
            id="Group-15"
            transform="translate(462.000000, 126.000000)"
            fill="#000000"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="20"
            fontWeight="normal"
          >
            <g id="Group-14">
              <text id="Vendredi">
                <tspan x="685.063415" y="19">
                  Vendredi
                </tspan>
              </text>
              <text id="Jeudi">
                <tspan x="523.454878" y="19">
                  Jeudi
                </tspan>
              </text>
              <text id="Mercredi">
                <tspan x="369.031707" y="19">
                  Mercredi
                </tspan>
              </text>
              <text id="Mardi">
                <tspan x="174.608537" y="19">
                  Mardi
                </tspan>
              </text>
              <text id="Lundi">
                <tspan x="0" y="19">
                  Lundi
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-6" transform="translate(100.500000, 15.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="148"
              height="49"
              rx="10"
            />
            <text
              id="2021/2022"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                2021/2022
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(114.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy" transform="translate(259.500000, 15.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="Plan-de-cours"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                Plan de cours
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy-2" transform="translate(441.500000, 15.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="5H-B"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                5H B
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6" transform="translate(26.000000, 403.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="261"
              height="49"
              rx="10"
            />
            <text
              id="Toutes-les-matières"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                Toutes les matières
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(229.753170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6" transform="translate(26.000000, 294.000000)">
            <path
              d="M23.5,0.5 L23.5,49.5 L10,49.5 C7.37664744,49.5 5.00164744,48.4366763 3.28248558,46.7175144 C1.56332372,44.9983526 0.5,42.6233526 0.5,40 L0.5,10 C0.5,7.37664744 1.56332372,5.00164744 3.28248558,3.28248558 C5.00164744,1.56332372 7.37664744,0.5 10,0.5 L23.5,0.5 Z"
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
            />
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(12.500000, 25.253143) rotate(90.000000) translate(-12.500000, -25.253143) translate(5.000026, 21.000026)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
            <path
              d="M273.5,0.5 L273.5,49.5 L260,49.5 C257.376647,49.5 255.001647,48.4366763 253.282486,46.7175144 C251.563324,44.9983526 250.5,42.6233526 250.5,40 L250.5,10 C250.5,7.37664744 251.563324,5.00164744 253.282486,3.28248558 C255.001647,1.56332372 257.376647,0.5 260,0.5 L273.5,0.5 Z"
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              transform="translate(262.000000, 25.000000) scale(-1, 1) translate(-262.000000, -25.000000) "
            />
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(262.500000, 25.253143) scale(-1, 1) rotate(90.000000) translate(-262.500000, -25.253143) translate(255.000026, 21.000026)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <text
            id="Matière"
            opacity="0.65"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fontWeight="normal"
            fill="#000000"
          >
            <tspan x="26" y="389">
              Matière
            </tspan>
          </text>
          <g id="Group-6" transform="translate(49.000000, 294.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="227"
              height="49"
            />
            <text
              id="01.10.2022-–-07.10.2"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="14" y="31">
                01.10.2022 – 07.10.2022
              </tspan>
            </text>
          </g>
          <text
            id="Semaine"
            opacity="0.65"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fontWeight="normal"
            fill="#000000"
          >
            <tspan x="26" y="282">
              Semaine
            </tspan>
          </text>
          <rect
            id="Rectangle"
            fill="#F59C05"
            x="26"
            y="464"
            width="262"
            height="43"
            rx="5"
          />
          <text
            id="Ajouter-une-entrée"
            fontFamily="Roboto-Bold, Roboto"
            fontSize="16"
            fontWeight="bold"
            fill="#FFFFFF"
          >
            <tspan x="96.328125" y="493">
              Ajouter une entrée
            </tspan>
          </text>
          <g
            id="SL/icons/naked-icon"
            transform="translate(46.537273, 478.633333)"
            fill="#FFFFFF"
          >
            <g
              id="iconfinder_add_134224"
              transform="translate(-0.000000, 0.000000)"
            >
              <path
                d="M17.1527778,7.6 L10.5555556,7.6 L10.5555556,1.26666667 C10.5555556,0.567466667 9.96444444,0 9.23611111,0 C8.50777778,0 7.91666667,0.567466667 7.91666667,1.26666667 L7.91666667,7.6 L1.31944444,7.6 C0.591111111,7.6 0,8.16746667 0,8.86666667 C0,9.56586667 0.591111111,10.1333333 1.31944444,10.1333333 L7.91666667,10.1333333 L7.91666667,16.4666667 C7.91666667,17.1658667 8.50777778,17.7333333 9.23611111,17.7333333 C9.96444444,17.7333333 10.5555556,17.1658667 10.5555556,16.4666667 L10.5555556,10.1333333 L17.1527778,10.1333333 C17.8811111,10.1333333 18.4722222,9.56586667 18.4722222,8.86666667 C18.4722222,8.16746667 17.8811111,7.6 17.1527778,7.6 Z"
                id="Path"
              />
            </g>
          </g>
          <rect
            id="Rectangle"
            fill="#FFFFFF"
            x="394"
            y="158"
            width="895"
            height="765"
          />
          <g id="full-time-table" transform="translate(394.000000, 158.000000)">
            <g id="timeslot" transform="translate(716.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 680.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 595.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 510.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <use id="Rectangle" fill="#FA6400" xlinkHref="#path-1" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-2)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-2)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-2)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-2)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Géographie
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:10
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 510.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-4" fill="white">
                    <use xlinkHref="#path-3" />
                  </mask>
                  <use id="Rectangle" fill="#E02020" xlinkHref="#path-3" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-4)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-4)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      005
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-4)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-4)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          ACM
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  15:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 510.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 510.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-6" fill="white">
                    <use xlinkHref="#path-5" />
                  </mask>
                  <use id="Rectangle" fill="#87B1CF" xlinkHref="#path-5" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-6)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-6)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-6)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-6)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Anglais
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  15:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 510.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-8" fill="white">
                    <use xlinkHref="#path-7" />
                  </mask>
                  <use id="Rectangle" fill="#F7B500" xlinkHref="#path-7" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-8)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-8)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-8)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-8)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Math
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  15:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 425.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-10" fill="white">
                    <use xlinkHref="#path-9" />
                  </mask>
                  <use id="Rectangle" fill="#F7B500" xlinkHref="#path-9" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-10)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-10)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-10)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-10)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Math
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  14:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 425.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-12" fill="white">
                    <use xlinkHref="#path-11" />
                  </mask>
                  <use id="Rectangle" fill="#44D7B6" xlinkHref="#path-11" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-12)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-12)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-12)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-12)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Biologie
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  14:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 425.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 425.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-14" fill="white">
                    <use xlinkHref="#path-13" />
                  </mask>
                  <use id="Rectangle" fill="#F7B500" xlinkHref="#path-13" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-14)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-14)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-14)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-14)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Math
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  14:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 425.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-16" fill="white">
                    <use xlinkHref="#path-15" />
                  </mask>
                  <use id="Rectangle" fill="#B7B7B7" xlinkHref="#path-15" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-16)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-16)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      001
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-16)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-16)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Gym
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  14:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 340.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-18" fill="white">
                    <use xlinkHref="#path-17" />
                  </mask>
                  <use id="Rectangle" fill="#F7B500" xlinkHref="#path-17" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-18)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-18)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-18)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-18)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Math
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  14:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 340.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-20" fill="white">
                    <use xlinkHref="#path-19" />
                  </mask>
                  <use id="Rectangle" fill="#44D7B6" xlinkHref="#path-19" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-20)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-20)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-20)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-20)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Biologie
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  14:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 340.000000)">
              <rect
                id="Rectangle"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 340.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-22" fill="white">
                    <use xlinkHref="#path-21" />
                  </mask>
                  <use id="Rectangle" fill="#E02020" xlinkHref="#path-21" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-22)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-22)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      005
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-22)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-22)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          ACM
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  14:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 340.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-24" fill="white">
                    <use xlinkHref="#path-23" />
                  </mask>
                  <use id="Rectangle" fill="#B7B7B7" xlinkHref="#path-23" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-24)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-24)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      001
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-24)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-24)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Gym
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  14:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 255.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-26" fill="white">
                    <use xlinkHref="#path-25" />
                  </mask>
                  <use id="Rectangle" fill="#87B1CF" xlinkHref="#path-25" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-26)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-26)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-26)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-26)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Anglais
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 255.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-28" fill="white">
                    <use xlinkHref="#path-27" />
                  </mask>
                  <use id="Rectangle" fill="#87B1CF" xlinkHref="#path-27" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-28)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-28)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-28)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-28)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Anglais
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 255.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-30" fill="white">
                    <use xlinkHref="#path-29" />
                  </mask>
                  <use id="Rectangle" fill="#6236FF" xlinkHref="#path-29" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-30)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-30)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-30)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-30)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Allemand
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 255.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-32" fill="white">
                    <use xlinkHref="#path-31" />
                  </mask>
                  <use id="Rectangle" fill="#6236FF" xlinkHref="#path-31" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-32)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-32)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-32)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-32)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Allemand
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 255.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-34" fill="white">
                    <use xlinkHref="#path-33" />
                  </mask>
                  <use id="Rectangle" fill="#B620E0" xlinkHref="#path-33" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-34)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-34)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-34)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-34)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Français
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:45
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 170.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-36" fill="white">
                    <use xlinkHref="#path-35" />
                  </mask>
                  <use id="Rectangle" fill="#B7B7B7" xlinkHref="#path-35" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-36)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-36)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-36)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-36)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Gym
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 170.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-38" fill="white">
                    <use xlinkHref="#path-37" />
                  </mask>
                  <use id="Rectangle" fill="#6DD400" xlinkHref="#path-37" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-38)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-38)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-38)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-38)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Histoire
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 170.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-40" fill="white">
                    <use xlinkHref="#path-39" />
                  </mask>
                  <use id="Rectangle" fill="#6236FF" xlinkHref="#path-39" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-40)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-40)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-40)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-40)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Allemand
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 170.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-42" fill="white">
                    <use xlinkHref="#path-41" />
                  </mask>
                  <use id="Rectangle" fill="#6236FF" xlinkHref="#path-41" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-42)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-42)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-42)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-42)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Allemand
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 170.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-44" fill="white">
                    <use xlinkHref="#path-43" />
                  </mask>
                  <use id="Rectangle" fill="#B620E0" xlinkHref="#path-43" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-44)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-44)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-44)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-44)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Français
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  10:00
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 85.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-46" fill="white">
                    <use xlinkHref="#path-45" />
                  </mask>
                  <use id="Rectangle" fill="#6DD400" xlinkHref="#path-45" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-46)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-46)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-46)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-46)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Histoire
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:55
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 85.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-48" fill="white">
                    <use xlinkHref="#path-47" />
                  </mask>
                  <use id="Rectangle" fill="#5692BD" xlinkHref="#path-47" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-48)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-48)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-48)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-48)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Chant
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:55
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 85.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-50" fill="white">
                    <use xlinkHref="#path-49" />
                  </mask>
                  <use id="Rectangle" fill="#B620E0" xlinkHref="#path-49" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-50)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-50)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-50)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-50)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Français
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:55
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 85.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-52" fill="white">
                    <use xlinkHref="#path-51" />
                  </mask>
                  <use id="Rectangle" fill="#B620E0" xlinkHref="#path-51" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-52)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-52)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-52)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-52)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Français
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:55
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(0.000000, 85.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-54" fill="white">
                    <use xlinkHref="#path-53" />
                  </mask>
                  <use id="Rectangle" fill="#44D7B6" xlinkHref="#path-53" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-54)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-54)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-54)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-54)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Biologie
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:55
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(716.000000, 0.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-56" fill="white">
                    <use xlinkHref="#path-55" />
                  </mask>
                  <use id="Rectangle" fill="#B620E0" xlinkHref="#path-55" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-56)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-56)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-56)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-56)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Français
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:10
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(537.000000, 0.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-58" fill="white">
                    <use xlinkHref="#path-57" />
                  </mask>
                  <use id="Rectangle" fill="#FA6400" xlinkHref="#path-57" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-58)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-58)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-58)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-58)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Géographie
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:10
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(358.000000, 0.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-60" fill="white">
                    <use xlinkHref="#path-59" />
                  </mask>
                  <use id="Rectangle" fill="#6DD400" xlinkHref="#path-59" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-60)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-60)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-60)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-60)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Histoire
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:10
                </tspan>
              </text>
            </g>
            <g id="timeslot" transform="translate(179.000000, 0.000000)">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-62" fill="white">
                    <use xlinkHref="#path-61" />
                  </mask>
                  <use id="Rectangle" fill="#B620E0" xlinkHref="#path-61" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-62)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-62)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-62)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-62)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Français
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:10
                </tspan>
              </text>
            </g>
            <g id="timeslot">
              <rect
                id="bg"
                stroke="#DDDDDD"
                fill="#EFF1F6"
                x="0"
                y="0"
                width="179"
                height="85"
              />
              <text
                id="+"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="25"
                fontWeight="400"
                fill="#C3BEBE"
              >
                <tspan x="83" y="51">
                  +
                </tspan>
              </text>
              <g
                id="plan/timeslot/geo"
                transform="translate(7.000000, 4.000000)"
              >
                <g id="Group-19">
                  <mask id="mask-64" fill="white">
                    <use xlinkHref="#path-63" />
                  </mask>
                  <use id="Rectangle" fill="#FA6400" xlinkHref="#path-63" />
                  <rect
                    id="Rectangle"
                    fill="#FFFFFF"
                    opacity="0.657163318"
                    mask="url(#mask-64)"
                    x="0"
                    y="0"
                    width="164"
                    height="76"
                  />
                  <text
                    id="203"
                    mask="url(#mask-64)"
                    fontFamily="Roboto-Italic, Roboto"
                    fontSize="14"
                    font-style="italic"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="15" y="66">
                      203
                    </tspan>
                  </text>
                  <text
                    id="MD"
                    mask="url(#mask-64)"
                    fontFamily="Roboto-Regular, Roboto"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#000000"
                  >
                    <tspan x="133" y="66">
                      MD
                    </tspan>
                  </text>
                  <g
                    id="Group"
                    mask="url(#mask-64)"
                    fontFamily="Roboto-Bold, Roboto"
                    fontSize="16"
                    fontWeight="bold"
                    line-spacing="22"
                  >
                    <g
                      transform="translate(14.733766, 6.000000)"
                      id="Group-3"
                      fill="#000000"
                    >
                      <text id="Géographie">
                        <tspan x="0" y="15">
                          Géographie
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
                <g
                  id="SL/icons/naked-icon"
                  transform="translate(142.117647, 9.000000)"
                  fill="#101010"
                  fillRule="nonzero"
                >
                  <g id="2849830_multimedia_options_setting_settings_gear_icon">
                    <path
                      d="M8.05138924,14.0000011 L5.94895242,14.0000011 C5.68170036,14.0000011 5.45750122,13.7983979 5.42935067,13.5326326 L5.2736791,12.0668124 C5.05636377,11.9928546 4.84406278,11.9049096 4.63810727,11.8035289 L3.49268492,12.7298967 C3.28509584,12.8970917 2.98492091,12.8811825 2.79616784,12.6929812 L1.30945212,11.2062655 C1.1212509,11.0175125 1.10534163,10.7173375 1.27253671,10.5097484 L2.19925269,9.36293307 C2.09769818,9.1570113 2.00963532,8.94470651 1.93562098,8.72736123 L0.467362964,8.57064489 C0.201730043,8.54250839 0,8.31851028 0,8.0513914 L0,5.94860632 C0,5.68148744 0.201730043,5.45748933 0.467362964,5.42935284 L1.93318317,5.27368127 C2.00719751,5.05633598 2.09526037,4.8440312 2.19681488,4.63810943 L1.2700989,3.49129405 C1.10290382,3.28370497 1.11881309,2.98353004 1.30701431,2.79477696 L2.79373003,1.30806125 C2.9824831,1.11986003 3.28265803,1.10395076 3.49024711,1.27114584 L4.63706249,2.19751356 C4.84301801,2.09613289 5.05531899,2.00818794 5.27263433,1.93423011 L5.4283059,0.468409902 C5.45599993,0.201832526 5.68094092,-0.000539134161 5.94895242,1.07898623e-06 L8.05138924,1.07898623e-06 C8.31864129,1.07898623e-06 8.54284044,0.201599792 8.57099098,0.467365126 L8.72631429,1.93318533 C8.94374324,2.00714189 9.15616015,2.09508668 9.36223439,2.19646879 L10.5087015,1.27010107 C10.7162906,1.10290598 11.0164655,1.11881526 11.2052186,1.30701647 L12.6919343,2.79373219 C12.8801355,2.98248527 12.8960448,3.28266019 12.7288497,3.49024927 L11.8021337,4.63706465 C11.9035422,4.84305261 11.9916011,5.05534783 12.0657655,5.27263649 L13.5315857,5.42830806 C13.7970806,5.45660995 13.9986013,5.68056241 13.9986013,5.94756155 L13.9986013,8.05034662 C13.9991133,8.31726686 13.7983188,8.54163999 13.5329787,8.57064489 L12.0671585,8.72631645 C11.9929941,8.94360512 11.9049352,9.15590033 11.8035268,9.36188829 L12.7302428,10.5087037 C12.8974378,10.7162928 12.8815286,11.0164677 12.6933273,11.2052208 L11.2066116,12.6929812 C11.0178586,12.8811825 10.7176836,12.8970917 10.5100945,12.7298967 L9.36362742,11.8035289 C9.15755319,11.904911 8.94513628,11.9928558 8.72770733,12.0668124 L8.57238402,13.5326326 C8.54417838,13.7989287 8.31917377,14.000771 8.05138924,14.0000011 Z M6.41805667,12.9552199 L7.58089195,12.9552199 L7.72332969,11.612335 C7.74620837,11.3971566 7.89938425,11.2183591 8.10850364,11.1627332 C8.47645982,11.0646123 8.82968873,10.917863 9.1588514,10.7263653 C9.34649525,10.6170286 9.58221364,10.6351928 9.75089092,10.7719871 L10.8012387,11.6206932 L11.6234771,10.7984548 L10.773378,9.75124134 C10.6365837,9.58256406 10.6184195,9.34684567 10.7277561,9.15920182 C10.9188513,8.83025319 11.0651372,8.47724609 11.1627311,8.10955058 C11.2184029,7.90032196 11.3973703,7.74711919 11.6126811,7.72437663 L12.9552178,7.58159063 L12.9552178,6.41875535 L11.6126811,6.27596935 C11.3973703,6.25322679 11.2184029,6.10002402 11.1627311,5.8907954 C11.0651665,5.52297968 10.9188798,5.16985367 10.7277561,4.8407959 C10.6184195,4.65315205 10.6365837,4.41743366 10.773378,4.24875638 L11.6220841,3.19840861 L10.7998457,2.3761702 L9.74949789,3.22487626 C9.5808206,3.36167059 9.34510221,3.37983478 9.15745837,3.27049813 C8.82844148,3.07954097 8.4754533,2.93326286 8.10780712,2.83552321 C7.89868774,2.77989732 7.74551185,2.60109979 7.72263317,2.38592143 L7.58158846,1.04477779 L6.41805667,1.04477779 L6.27561893,2.38766273 C6.25269017,2.60293687 6.09935273,2.78176129 5.89009672,2.83726451 C5.52271355,2.93544858 5.1700684,3.08219863 4.84149025,3.27363246 C4.65384641,3.3829691 4.41812802,3.36480492 4.24945073,3.22801059 L3.20014774,2.37791149 L2.37825758,3.20014991 L3.22731191,4.25049767 C3.36399489,4.41924995 3.38202009,4.65496416 3.27258552,4.84253719 C3.08178027,5.17162921 2.93551077,5.52459661 2.8376106,5.89218844 C2.7819847,6.10130782 2.60318718,6.25448371 2.38800882,6.27736239 L1.04512389,6.42014839 L1.04512389,7.5826354 L2.38800882,7.7254214 C2.60318718,7.74830008 2.7819847,7.90147597 2.8376106,8.11059535 C2.93548794,8.47780929 3.08163784,8.83041935 3.27223726,9.15920182 C3.38167183,9.34677486 3.36364663,9.58248906 3.22696365,9.75124134 L2.37825758,10.7998478 L3.200496,11.6220862 L4.25119202,10.7733802 C4.41986931,10.6365858 4.6555877,10.6184217 4.84323155,10.7277583 C5.1721006,10.9187652 5.52498059,11.065047 5.89253453,11.1627332 C6.10179054,11.2182364 6.25512798,11.3970609 6.27805674,11.612335 L6.41805667,12.9552199 Z"
                      id="Shape"
                    />
                    <path
                      d="M6.9999967,10.1816889 C5.24284316,10.1814966 3.81852671,8.75692026 3.81865492,6.99976671 C3.81878314,5.24261317 5.24330748,3.81824474 7.00046103,3.81830884 C8.75761458,3.81837294 10.182035,5.24284531 10.182035,6.99999886 C10.1801153,8.75653791 8.75653595,10.1799615 6.9999967,10.1816889 Z M6.9999967,4.86308445 C5.81985681,4.86327678 4.86330234,5.8200911 4.86343055,7.000231 C4.86355877,8.18037089 5.82032112,9.13697734 7.00046102,9.13691324 C8.18060093,9.13684914 9.13725937,8.18013877 9.13725937,6.99999886 C9.13591558,5.82023474 8.17976103,4.86423598 6.9999967,4.86308445 L6.9999967,4.86308445 Z"
                      id="Shape"
                    />
                  </g>
                </g>
              </g>
              <text
                id="08:10"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="22" y="47">
                  08:10
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-15" transform="translate(393.500000, 119.478002)">
            <g id="Group-14-Copy-3" transform="translate(716.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Vendredi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="50.3714558" y="26">
                  Vendredi
                </tspan>
              </text>
            </g>
            <g id="Group-14-Copy-2" transform="translate(537.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Jeudi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="65.234737" y="26">
                  Jeudi
                </tspan>
              </text>
            </g>
            <g id="Group-14-Copy" transform="translate(358.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Mercredi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="50.4202839" y="26">
                  Mercredi
                </tspan>
              </text>
            </g>
            <g id="Group-14" transform="translate(179.000000, 0.000000)">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Mardi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="64.1019245" y="26">
                  Mardi
                </tspan>
              </text>
            </g>
            <g id="Group-14">
              <rect
                id="Rectangle"
                stroke="#CECECE"
                fill="#005D9F"
                x="0.5"
                y="0.5"
                width="178"
                height="37"
              />
              <text
                id="Lundi"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="20"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="65.366573" y="26">
                  Lundi
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-20" transform="translate(24.000000, 121.000000)">
            <text
              id="Plan"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#000000"
            >
              <tspan x="13.9492188" y="15">
                Plan
              </tspan>
            </text>
            <g id="Group-19" transform="translate(0.000000, 35.000000)">
              <line
                x1="0.5"
                y1="0.5"
                x2="0.5"
                y2="50.5"
                id="Line-4"
                stroke="#ECE9E9"
                strokeLinecap="square"
              />
              <g id="Group-14" transform="translate(0.000000, 2.000000)">
                <line
                  x1="0.5"
                  y1="0.5"
                  x2="0.5"
                  y2="16.5"
                  id="Line-4"
                  stroke="#005D9F"
                  strokeWidth="2"
                  strokeLinecap="square"
                />
                <text
                  id="Import-/-Export"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#8C8C8C"
                >
                  <tspan x="15" y="44">
                    Import / Export
                  </tspan>
                </text>
                <text
                  id="Paramètres-Copy-04"
                  onClick={planSettings05StepCallback}
                  className="clickable-svg-part"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#8C8C8C"
                >
                  <tspan x="15" y="78">
                    Paramètres
                  </tspan>
                </text>
              </g>
              <text
                id="Plan-de-cours"
                onClick={plan01StepCallback}
                className="clickable-svg-part"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="14"
                fontWeight="bold"
                fill="#005D9F"
              >
                <tspan x="15" y="15">
                  Plan de cours
                </tspan>
              </text>
            </g>
          </g>
          <g
            id="mobile/btn/primary/default"
            transform="translate(1117.000000, 16.000000)"
          >
            <rect
              id="Rectangle"
              fill="#005D9F"
              x="0"
              y="0"
              width="172"
              height="50"
              rx="10"
            />
            <text
              id="Primary"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#FFFFFF"
            >
              <tspan x="36.8828125" y="31">
                Nouveau plan
              </tspan>
            </text>
          </g>
        </g>
      </svg>
    ),
    [nextStep, plan01StepCallback, planSettings05StepCallback],
  );
  const step05 = useMemo(
    () => (
      <svg
        width="1349px"
        height="1515px"
        viewBox="0 0 1349 1515"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnslink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <rect id="path-1" x="0" y="0" width="669" height="50" rx="10" />
          <mask
            id="mask-2"
            maskContentUnits="userSpaceOnUse"
            maskUnits="objectBoundingBox"
            x="0"
            y="0"
            width="669"
            height="50"
            fill="white"
          >
            <use xlinkHref="#path-1" />
          </mask>
          <rect id="path-3" x="0" y="0" width="669" height="50" rx="10" />
          <mask
            id="mask-4"
            maskContentUnits="userSpaceOnUse"
            maskUnits="objectBoundingBox"
            x="0"
            y="0"
            width="669"
            height="50"
            fill="white"
          >
            <use xlinkHref="#path-3" />
          </mask>
        </defs>
        <g
          id="step05"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect fill="#F1F3F9" x="0" y="0" width="1349" height="1515" />
          <g
            id="Group-2"
            transform="translate(22.000000, 29.000000)"
            fill="#000000"
            fontFamily="Roboto-Medium, Roboto"
            fontSize="20"
            fontWeight="400"
          >
            <text id="Plans">
              <tspan x="0" y="19">
                Plans
              </tspan>
            </text>
          </g>
          <line
            x1="350.5"
            y1="78.5"
            x2="0.5"
            y2="78.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <line
            x1="351.5"
            y1="78.5"
            x2="1349.5"
            y2="78.5"
            id="Line-3"
            stroke="#C8C6C6"
            strokeLinecap="square"
          />
          <g id="Group-6" transform="translate(100.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="148"
              height="49"
              rx="10"
            />
            <text
              id="2021/2022"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                2021/2022
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(114.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy" transform="translate(259.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="Plan-de-cours"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                Plan de cours
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-6-Copy-2" transform="translate(441.500000, 16.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="171"
              height="49"
              rx="10"
            />
            <text
              id="5H-B"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                5H B
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(141.253170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <g id="Group-20" transform="translate(24.000000, 121.000000)">
            <text
              id="Plan"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#000000"
            >
              <tspan x="13.9492188" y="15">
                Plan
              </tspan>
            </text>
            <g id="Group-19" transform="translate(0.000000, 35.000000)">
              <line
                x1="0.5"
                y1="0.5"
                x2="0.5"
                y2="50.5"
                id="Line-4"
                stroke="#ECE9E9"
                strokeLinecap="square"
              />
              <g id="Group-14" transform="translate(0.000000, 33.000000)">
                <line
                  x1="0.5"
                  y1="33.5"
                  x2="0.5"
                  y2="49.5"
                  id="Line-4"
                  stroke="#005D9F"
                  strokeWidth="2"
                  strokeLinecap="square"
                />
                <text
                  id="Import-/-Export"
                  fontFamily="Roboto-Regular, Roboto"
                  fontSize="14"
                  fontWeight="normal"
                  fill="#8C8C8C"
                >
                  <tspan x="15" y="13">
                    Import / Export
                  </tspan>
                </text>
                <text
                  id="Paramètres-Copy-05"
                  className="clickable-svg-part"
                  fontFamily="Roboto-Medium, Roboto"
                  fontSize="14"
                  fontWeight="400"
                  fill="#005D9F"
                >
                  <tspan x="15" y="47">
                    Paramètres
                  </tspan>
                </text>
              </g>
              <text
                id="Plan-de-cours-05"
                onClick={plan01StepCallback}
                className="clickable-svg-part"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#A9A9A9"
              >
                <tspan x="15" y="15">
                  Plan de cours
                </tspan>
              </text>
            </g>
          </g>
          <g
            id="mobile/btn/primary/default"
            transform="translate(1117.000000, 16.000000)"
          >
            <rect
              id="Rectangle"
              fill="#005D9F"
              x="0"
              y="0"
              width="172"
              height="50"
              rx="10"
            />
            <text
              id="Primary"
              fontFamily="Roboto-Bold, Roboto"
              fontSize="16"
              fontWeight="bold"
              fill="#FFFFFF"
            >
              <tspan x="36.8828125" y="31">
                Nouveau plan
              </tspan>
            </text>
          </g>
          <g id="Group-6" transform="translate(293.000000, 146.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="261"
              height="49"
              rx="10"
            />
            <text
              id="Plan-de-cours"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                Plan de cours
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(229.753170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <text
            id="Type-de-plan"
            opacity="0.65"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fontWeight="normal"
            fill="#000000"
          >
            <tspan x="293" y="132">
              Type de plan
            </tspan>
          </text>
          <g id="Group-6" transform="translate(293.000000, 250.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="261"
              height="49"
              rx="10"
            />
            <text
              id="5H-B"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                5H B
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(229.753170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <text
            id="Classe"
            opacity="0.65"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fontWeight="normal"
            fill="#000000"
          >
            <tspan x="293" y="236">
              Classe
            </tspan>
          </text>
          <g id="Group-6" transform="translate(293.000000, 354.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="261"
              height="49"
              rx="10"
            />
            <text
              id="35"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                35
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(229.753170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <text
            id="Nombre-de-périodes"
            opacity="0.65"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fontWeight="normal"
            fill="#000000"
          >
            <tspan x="293" y="340">
              Nombre de périodes
            </tspan>
          </text>
          <g id="Group-6" transform="translate(293.000000, 461.000000)">
            <rect
              id="Rectangle"
              stroke="#999999"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="262"
              height="49"
              rx="10"
            />
            <text
              id="45-minutes"
              fontFamily="Roboto-Medium, Roboto"
              fontSize="16"
              fontWeight="400"
              fill="#000000"
            >
              <tspan x="16" y="30">
                45 minutes
              </tspan>
            </text>
            <g
              id="SL/icons/icon/arrow-short"
              transform="translate(229.753170, 21.246883)"
              fill="#101010"
            >
              <path
                d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                id="Path"
                transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
              />
            </g>
          </g>
          <text
            id="Durée-de-la-période"
            opacity="0.65"
            fontFamily="Roboto-Regular, Roboto"
            fontSize="14"
            fontWeight="normal"
            fill="#000000"
          >
            <tspan x="293" y="447">
              Durée de la période
            </tspan>
          </text>
          <g id="Group-13" transform="translate(295.000000, 553.000000)">
            <text
              id="Validité-du-Plan-de"
              opacity="0.65"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="14"
              fontWeight="normal"
              fill="#000000"
            >
              <tspan x="0" y="13">
                Validité du Plan de cours
              </tspan>
            </text>
            <g id="Group-11" transform="translate(2.000000, 30.000000)">
              <text
                id="Du"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="0" y="29">
                  Du
                </tspan>
              </text>
              <rect
                id="Rectangle"
                stroke="#999999"
                fill="#FFFFFF"
                x="34.5"
                y="0.5"
                width="156"
                height="49"
                rx="10"
              />
              <text
                id="18.08.2022"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="16"
                fontWeight="400"
                fill="#000000"
              >
                <tspan x="84" y="31">
                  18.08.2022
                </tspan>
              </text>
              <g
                id="SL/icons/naked-icon"
                transform="translate(53.483871, 18.500000)"
                fill="#101010"
              >
                <path
                  d="M3.21110738,0 C3.04988419,0 2.91918496,0.135287542 2.91918496,0.302174417 L2.91918496,1.81304071 L1.16767286,1.81304071 C0.522785726,1.81304071 7.73574753e-15,2.35419667 7.73574753e-15,3.02173837 L7.73574753e-15,12.6912792 C7.73574753e-15,13.3588267 0.522785726,13.9 1.16767286,13.9 L12.8444407,13.9 C13.4893335,13.9 14.0120968,13.3588267 14.0120968,12.6912792 L14.0120968,3.02173837 C14.0120968,2.35419667 13.4893335,1.81304071 12.8444407,1.81304071 L11.0929286,1.81304071 L11.0929286,0.302174417 C11.0929286,0.135287542 10.9622238,0 10.8009726,0 L10.2171726,0 C10.0559214,0 9.92521653,0.135287542 9.92521653,0.302174417 L9.92521653,1.81304071 L4.08686343,1.81304071 L4.08686343,0.302174417 C4.08686343,0.135287542 3.95616419,0 3.79494101,0 L3.21110738,0 Z M9.92521653,3.02173837 L4.08686343,3.02173837 L4.08686343,3.62608721 C4.08686343,3.79297408 3.95616419,3.92826162 3.79494101,3.92826162 L3.21110738,3.92826162 C3.04988419,3.92826162 2.91918496,3.79297408 2.91918496,3.62608721 L2.91918496,3.02173837 L1.7515121,3.02173837 C1.42906573,3.02173837 1.16767286,3.29231346 1.16767286,3.62608721 L1.16767286,4.8347675 L12.8444407,4.8347675 L12.8444407,3.62608721 C12.8444407,3.29231346 12.583031,3.02173837 12.2605847,3.02173837 L11.0929286,3.02173837 L11.0929286,3.62608721 C11.0929286,3.79297408 10.9622238,3.92826162 10.8009726,3.92826162 L10.2171726,3.92826162 C10.0559214,3.92826162 9.92521653,3.79297408 9.92521653,3.62608721 L9.92521653,3.02173837 Z M1.16767286,6.04348833 L12.8444407,6.04348833 L12.8444407,12.0869767 C12.8444407,12.4207504 12.583031,12.6912792 12.2605847,12.6912792 L1.7515121,12.6912792 C1.42906573,12.6912792 1.16767286,12.4207504 1.16767286,12.0869767 L1.16767286,6.04348833 Z"
                  id="Shape"
                />
              </g>
            </g>
            <g id="Group-12" transform="translate(215.000000, 30.000000)">
              <text
                id="Au"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="0" y="29">
                  Au
                </tspan>
              </text>
              <rect
                id="Rectangle"
                stroke="#999999"
                fill="#FFFFFF"
                x="29.5"
                y="0.5"
                width="156"
                height="49"
                rx="10"
              />
              <text
                id="23.06.2023"
                fontFamily="Roboto-Medium, Roboto"
                fontSize="16"
                fontWeight="400"
                fill="#000000"
              >
                <tspan x="79" y="31">
                  23.06.2023
                </tspan>
              </text>
              <g
                id="SL/icons/naked-icon"
                transform="translate(48.483871, 18.500000)"
                fill="#101010"
              >
                <path
                  d="M3.21110738,0 C3.04988419,0 2.91918496,0.135287542 2.91918496,0.302174417 L2.91918496,1.81304071 L1.16767286,1.81304071 C0.522785726,1.81304071 7.73574753e-15,2.35419667 7.73574753e-15,3.02173837 L7.73574753e-15,12.6912792 C7.73574753e-15,13.3588267 0.522785726,13.9 1.16767286,13.9 L12.8444407,13.9 C13.4893335,13.9 14.0120968,13.3588267 14.0120968,12.6912792 L14.0120968,3.02173837 C14.0120968,2.35419667 13.4893335,1.81304071 12.8444407,1.81304071 L11.0929286,1.81304071 L11.0929286,0.302174417 C11.0929286,0.135287542 10.9622238,0 10.8009726,0 L10.2171726,0 C10.0559214,0 9.92521653,0.135287542 9.92521653,0.302174417 L9.92521653,1.81304071 L4.08686343,1.81304071 L4.08686343,0.302174417 C4.08686343,0.135287542 3.95616419,0 3.79494101,0 L3.21110738,0 Z M9.92521653,3.02173837 L4.08686343,3.02173837 L4.08686343,3.62608721 C4.08686343,3.79297408 3.95616419,3.92826162 3.79494101,3.92826162 L3.21110738,3.92826162 C3.04988419,3.92826162 2.91918496,3.79297408 2.91918496,3.62608721 L2.91918496,3.02173837 L1.7515121,3.02173837 C1.42906573,3.02173837 1.16767286,3.29231346 1.16767286,3.62608721 L1.16767286,4.8347675 L12.8444407,4.8347675 L12.8444407,3.62608721 C12.8444407,3.29231346 12.583031,3.02173837 12.2605847,3.02173837 L11.0929286,3.02173837 L11.0929286,3.62608721 C11.0929286,3.79297408 10.9622238,3.92826162 10.8009726,3.92826162 L10.2171726,3.92826162 C10.0559214,3.92826162 9.92521653,3.79297408 9.92521653,3.62608721 L9.92521653,3.02173837 Z M1.16767286,6.04348833 L12.8444407,6.04348833 L12.8444407,12.0869767 C12.8444407,12.4207504 12.583031,12.6912792 12.2605847,12.6912792 L1.7515121,12.6912792 C1.42906573,12.6912792 1.16767286,12.4207504 1.16767286,12.0869767 L1.16767286,6.04348833 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
          <g id="Group-10" transform="translate(673.000000, 1334.000000)">
            <g id="Group">
              <rect
                id="Annuler-05-Rectangle"
                onClick={plan01StepCallback}
                className="clickable-svg-part"
                stroke="#999999"
                fill="#FFFFFF"
                x="0.5"
                y="0.5"
                width="140"
                height="49"
                rx="10"
              />
              <text
                id="Secondary"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="16"
                fontWeight="bold"
                fill="#000000"
              >
                <tspan x="42.5039062" y="31">
                  Annuler
                </tspan>
              </text>
            </g>
            <g
              id="Sauveguarder-05-group"
              onClick={plan01StepCallback}
              className="clickable-svg-part"
              transform="translate(151.000000, 0.000000)"
            >
              <rect
                id="Rectangle"
                fill="#005D9F"
                x="0"
                y="0"
                width="141"
                height="50"
                rx="10"
              />
              <text
                id="Primary"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="16"
                fontWeight="bold"
                fill="#FFFFFF"
              >
                <tspan x="20.5742188" y="31">
                Sauvegarder
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-8" transform="translate(296.000000, 686.000000)">
            <g id="Group">
              <g id="Group-3" transform="translate(0.000000, 27.000000)">
                <g id="Group-4" transform="translate(0.000000, 70.000000)">
                  <g id="Group-6">
                    <rect
                      id="Rectangle"
                      stroke="#999999"
                      fill="#FFFFFF"
                      x="0.5"
                      y="0.5"
                      width="261"
                      height="49"
                      rx="10"
                    />
                    <text
                      id="Immaculée-Conception"
                      fontFamily="Roboto-Medium, Roboto"
                      fontSize="16"
                      fontWeight="400"
                      fill="#000000"
                    >
                      <tspan x="16" y="30">
                        Immaculée Conception
                      </tspan>
                    </text>
                    <g
                      id="SL/icons/icon/arrow-short"
                      transform="translate(229.753170, 21.246883)"
                      fill="#FFFFFF"
                    >
                      <path
                        d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                        id="Path"
                        transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
                      />
                    </g>
                  </g>
                  <g id="Group-6" transform="translate(277.000000, 0.000000)">
                    <rect
                      id="Rectangle"
                      stroke="#999999"
                      fill="#FFFFFF"
                      x="0.5"
                      y="0.5"
                      width="156"
                      height="49"
                      rx="10"
                    />
                    <text
                      id="08.12.2022"
                      fontFamily="Roboto-Medium, Roboto"
                      fontSize="16"
                      fontWeight="400"
                      fill="#000000"
                    >
                      <tspan x="50" y="31">
                        08.12.2022
                      </tspan>
                    </text>
                    <g
                      id="SL/icons/naked-icon"
                      transform="translate(19.483871, 18.500000)"
                      fill="#101010"
                    >
                      <path
                        d="M3.21110738,0 C3.04988419,0 2.91918496,0.135287542 2.91918496,0.302174417 L2.91918496,1.81304071 L1.16767286,1.81304071 C0.522785726,1.81304071 7.73574753e-15,2.35419667 7.73574753e-15,3.02173837 L7.73574753e-15,12.6912792 C7.73574753e-15,13.3588267 0.522785726,13.9 1.16767286,13.9 L12.8444407,13.9 C13.4893335,13.9 14.0120968,13.3588267 14.0120968,12.6912792 L14.0120968,3.02173837 C14.0120968,2.35419667 13.4893335,1.81304071 12.8444407,1.81304071 L11.0929286,1.81304071 L11.0929286,0.302174417 C11.0929286,0.135287542 10.9622238,0 10.8009726,0 L10.2171726,0 C10.0559214,0 9.92521653,0.135287542 9.92521653,0.302174417 L9.92521653,1.81304071 L4.08686343,1.81304071 L4.08686343,0.302174417 C4.08686343,0.135287542 3.95616419,0 3.79494101,0 L3.21110738,0 Z M9.92521653,3.02173837 L4.08686343,3.02173837 L4.08686343,3.62608721 C4.08686343,3.79297408 3.95616419,3.92826162 3.79494101,3.92826162 L3.21110738,3.92826162 C3.04988419,3.92826162 2.91918496,3.79297408 2.91918496,3.62608721 L2.91918496,3.02173837 L1.7515121,3.02173837 C1.42906573,3.02173837 1.16767286,3.29231346 1.16767286,3.62608721 L1.16767286,4.8347675 L12.8444407,4.8347675 L12.8444407,3.62608721 C12.8444407,3.29231346 12.583031,3.02173837 12.2605847,3.02173837 L11.0929286,3.02173837 L11.0929286,3.62608721 C11.0929286,3.79297408 10.9622238,3.92826162 10.8009726,3.92826162 L10.2171726,3.92826162 C10.0559214,3.92826162 9.92521653,3.79297408 9.92521653,3.62608721 L9.92521653,3.02173837 Z M1.16767286,6.04348833 L12.8444407,6.04348833 L12.8444407,12.0869767 C12.8444407,12.4207504 12.583031,12.6912792 12.2605847,12.6912792 L1.7515121,12.6912792 C1.42906573,12.6912792 1.16767286,12.4207504 1.16767286,12.0869767 L1.16767286,6.04348833 Z"
                        id="Shape"
                      />
                    </g>
                  </g>
                  <g id="Group-6" transform="translate(449.000000, 0.000000)">
                    <rect
                      id="Rectangle"
                      stroke="#999999"
                      fill="#FFFFFF"
                      x="0.5"
                      y="0.5"
                      width="156"
                      height="49"
                      rx="10"
                    />
                    <text
                      id="08.12.2022"
                      fontFamily="Roboto-Medium, Roboto"
                      fontSize="16"
                      fontWeight="400"
                      fill="#000000"
                    >
                      <tspan x="50" y="31">
                        08.12.2022
                      </tspan>
                    </text>
                    <g
                      id="SL/icons/naked-icon"
                      transform="translate(19.483871, 18.500000)"
                      fill="#101010"
                    >
                      <path
                        d="M3.21110738,0 C3.04988419,0 2.91918496,0.135287542 2.91918496,0.302174417 L2.91918496,1.81304071 L1.16767286,1.81304071 C0.522785726,1.81304071 7.73574753e-15,2.35419667 7.73574753e-15,3.02173837 L7.73574753e-15,12.6912792 C7.73574753e-15,13.3588267 0.522785726,13.9 1.16767286,13.9 L12.8444407,13.9 C13.4893335,13.9 14.0120968,13.3588267 14.0120968,12.6912792 L14.0120968,3.02173837 C14.0120968,2.35419667 13.4893335,1.81304071 12.8444407,1.81304071 L11.0929286,1.81304071 L11.0929286,0.302174417 C11.0929286,0.135287542 10.9622238,0 10.8009726,0 L10.2171726,0 C10.0559214,0 9.92521653,0.135287542 9.92521653,0.302174417 L9.92521653,1.81304071 L4.08686343,1.81304071 L4.08686343,0.302174417 C4.08686343,0.135287542 3.95616419,0 3.79494101,0 L3.21110738,0 Z M9.92521653,3.02173837 L4.08686343,3.02173837 L4.08686343,3.62608721 C4.08686343,3.79297408 3.95616419,3.92826162 3.79494101,3.92826162 L3.21110738,3.92826162 C3.04988419,3.92826162 2.91918496,3.79297408 2.91918496,3.62608721 L2.91918496,3.02173837 L1.7515121,3.02173837 C1.42906573,3.02173837 1.16767286,3.29231346 1.16767286,3.62608721 L1.16767286,4.8347675 L12.8444407,4.8347675 L12.8444407,3.62608721 C12.8444407,3.29231346 12.583031,3.02173837 12.2605847,3.02173837 L11.0929286,3.02173837 L11.0929286,3.62608721 C11.0929286,3.79297408 10.9622238,3.92826162 10.8009726,3.92826162 L10.2171726,3.92826162 C10.0559214,3.92826162 9.92521653,3.79297408 9.92521653,3.62608721 L9.92521653,3.02173837 Z M1.16767286,6.04348833 L12.8444407,6.04348833 L12.8444407,12.0869767 C12.8444407,12.4207504 12.583031,12.6912792 12.2605847,12.6912792 L1.7515121,12.6912792 C1.42906573,12.6912792 1.16767286,12.4207504 1.16767286,12.0869767 L1.16767286,6.04348833 Z"
                        id="Shape"
                      />
                    </g>
                    <g
                      id="SL/icons/icon/arrow-short"
                      transform="translate(200.000000, 18.000000)"
                      fill="#101010"
                      fillRule="nonzero"
                    >
                      <g id="iconfinder_trash-bin-garbage-delete-rubbish-waste_3643729">
                        <path
                          d="M10.5,15 L2.5,15 C1.67157288,15 1,14.3284271 1,13.5 L1,4 C1,3.72385763 1.22385763,3.5 1.5,3.5 C1.77614237,3.5 2,3.72385763 2,4 L2,13.5 C2,13.7761424 2.22385763,14 2.5,14 L10.5,14 C10.7761424,14 11,13.7761424 11,13.5 L11,4 C11,3.72385763 11.2238576,3.5 11.5,3.5 C11.7761424,3.5 12,3.72385763 12,4 L12,13.5 C12,14.3284271 11.3284271,15 10.5,15 Z"
                          id="Path"
                        />
                        <path
                          d="M12.5,3 L0.5,3 C0.223857625,3 0,2.77614237 0,2.5 C0,2.22385763 0.223857625,2 0.5,2 L12.5,2 C12.7761424,2 13,2.22385763 13,2.5 C13,2.77614237 12.7761424,3 12.5,3 Z"
                          id="Path"
                        />
                        <path
                          d="M8.5,3 C8.22385763,3 8,2.77614237 8,2.5 L8,1 L5,1 L5,2.5 C5,2.77614237 4.77614237,3 4.5,3 C4.22385763,3 4,2.77614237 4,2.5 L4,0.5 C4,0.223857625 4.22385763,0 4.5,0 L8.5,0 C8.77614237,0 9,0.223857625 9,0.5 L9,2.5 C9,2.77614237 8.77614237,3 8.5,3 Z"
                          id="Path"
                        />
                        <path
                          d="M6.5,12.5 C6.22385763,12.5 6,12.2761424 6,12 L6,5 C6,4.72385763 6.22385763,4.5 6.5,4.5 C6.77614237,4.5 7,4.72385763 7,5 L7,12 C7,12.2761424 6.77614237,12.5 6.5,12.5 Z"
                          id="Path"
                        />
                        <path
                          d="M9,11.5 C8.72385763,11.5 8.5,11.2761424 8.5,11 L8.5,6 C8.5,5.72385763 8.72385763,5.5 9,5.5 C9.27614237,5.5 9.5,5.72385763 9.5,6 L9.5,11 C9.5,11.2761424 9.27614237,11.5 9,11.5 Z"
                          id="Path"
                        />
                        <path
                          d="M4,11.5 C3.72385763,11.5 3.5,11.2761424 3.5,11 L3.5,6 C3.5,5.72385763 3.72385763,5.5 4,5.5 C4.27614237,5.5 4.5,5.72385763 4.5,6 L4.5,11 C4.5,11.2761424 4.27614237,11.5 4,11.5 Z"
                          id="Path"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group-5">
                  <g id="Group-6">
                    <rect
                      id="Rectangle"
                      stroke="#999999"
                      fill="#FFFFFF"
                      x="0.5"
                      y="0.5"
                      width="261"
                      height="49"
                      rx="10"
                    />
                    <text
                      id="Vacances-automnes"
                      fontFamily="Roboto-Medium, Roboto"
                      fontSize="16"
                      fontWeight="400"
                      fill="#000000"
                    >
                      <tspan x="16" y="30">
                        Vacances automnes
                      </tspan>
                    </text>
                    <g
                      id="SL/icons/icon/arrow-short"
                      transform="translate(229.753170, 21.246883)"
                      fill="#FFFFFF"
                    >
                      <path
                        d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                        id="Path"
                        transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
                      />
                    </g>
                  </g>
                  <g id="Group-6" transform="translate(277.000000, 0.000000)">
                    <rect
                      id="Rectangle"
                      stroke="#999999"
                      fill="#FFFFFF"
                      x="0.5"
                      y="0.5"
                      width="156"
                      height="49"
                      rx="10"
                    />
                    <text
                      id="12.10.2022"
                      fontFamily="Roboto-Medium, Roboto"
                      fontSize="16"
                      fontWeight="400"
                      fill="#000000"
                    >
                      <tspan x="50" y="31">
                        12.10.2022
                      </tspan>
                    </text>
                    <g
                      id="SL/icons/naked-icon"
                      transform="translate(19.483871, 18.500000)"
                      fill="#101010"
                    >
                      <path
                        d="M3.21110738,0 C3.04988419,0 2.91918496,0.135287542 2.91918496,0.302174417 L2.91918496,1.81304071 L1.16767286,1.81304071 C0.522785726,1.81304071 7.73574753e-15,2.35419667 7.73574753e-15,3.02173837 L7.73574753e-15,12.6912792 C7.73574753e-15,13.3588267 0.522785726,13.9 1.16767286,13.9 L12.8444407,13.9 C13.4893335,13.9 14.0120968,13.3588267 14.0120968,12.6912792 L14.0120968,3.02173837 C14.0120968,2.35419667 13.4893335,1.81304071 12.8444407,1.81304071 L11.0929286,1.81304071 L11.0929286,0.302174417 C11.0929286,0.135287542 10.9622238,0 10.8009726,0 L10.2171726,0 C10.0559214,0 9.92521653,0.135287542 9.92521653,0.302174417 L9.92521653,1.81304071 L4.08686343,1.81304071 L4.08686343,0.302174417 C4.08686343,0.135287542 3.95616419,0 3.79494101,0 L3.21110738,0 Z M9.92521653,3.02173837 L4.08686343,3.02173837 L4.08686343,3.62608721 C4.08686343,3.79297408 3.95616419,3.92826162 3.79494101,3.92826162 L3.21110738,3.92826162 C3.04988419,3.92826162 2.91918496,3.79297408 2.91918496,3.62608721 L2.91918496,3.02173837 L1.7515121,3.02173837 C1.42906573,3.02173837 1.16767286,3.29231346 1.16767286,3.62608721 L1.16767286,4.8347675 L12.8444407,4.8347675 L12.8444407,3.62608721 C12.8444407,3.29231346 12.583031,3.02173837 12.2605847,3.02173837 L11.0929286,3.02173837 L11.0929286,3.62608721 C11.0929286,3.79297408 10.9622238,3.92826162 10.8009726,3.92826162 L10.2171726,3.92826162 C10.0559214,3.92826162 9.92521653,3.79297408 9.92521653,3.62608721 L9.92521653,3.02173837 Z M1.16767286,6.04348833 L12.8444407,6.04348833 L12.8444407,12.0869767 C12.8444407,12.4207504 12.583031,12.6912792 12.2605847,12.6912792 L1.7515121,12.6912792 C1.42906573,12.6912792 1.16767286,12.4207504 1.16767286,12.0869767 L1.16767286,6.04348833 Z"
                        id="Shape"
                      />
                    </g>
                  </g>
                  <g id="Group-6" transform="translate(449.000000, 0.000000)">
                    <rect
                      id="Rectangle"
                      stroke="#999999"
                      fill="#FFFFFF"
                      x="0.5"
                      y="0.5"
                      width="156"
                      height="49"
                      rx="10"
                    />
                    <text
                      id="24.10.2022"
                      fontFamily="Roboto-Medium, Roboto"
                      fontSize="16"
                      fontWeight="400"
                      fill="#000000"
                    >
                      <tspan x="50" y="31">
                        24.10.2022
                      </tspan>
                    </text>
                    <g
                      id="SL/icons/naked-icon"
                      transform="translate(19.483871, 18.500000)"
                      fill="#101010"
                    >
                      <path
                        d="M3.21110738,0 C3.04988419,0 2.91918496,0.135287542 2.91918496,0.302174417 L2.91918496,1.81304071 L1.16767286,1.81304071 C0.522785726,1.81304071 7.73574753e-15,2.35419667 7.73574753e-15,3.02173837 L7.73574753e-15,12.6912792 C7.73574753e-15,13.3588267 0.522785726,13.9 1.16767286,13.9 L12.8444407,13.9 C13.4893335,13.9 14.0120968,13.3588267 14.0120968,12.6912792 L14.0120968,3.02173837 C14.0120968,2.35419667 13.4893335,1.81304071 12.8444407,1.81304071 L11.0929286,1.81304071 L11.0929286,0.302174417 C11.0929286,0.135287542 10.9622238,0 10.8009726,0 L10.2171726,0 C10.0559214,0 9.92521653,0.135287542 9.92521653,0.302174417 L9.92521653,1.81304071 L4.08686343,1.81304071 L4.08686343,0.302174417 C4.08686343,0.135287542 3.95616419,0 3.79494101,0 L3.21110738,0 Z M9.92521653,3.02173837 L4.08686343,3.02173837 L4.08686343,3.62608721 C4.08686343,3.79297408 3.95616419,3.92826162 3.79494101,3.92826162 L3.21110738,3.92826162 C3.04988419,3.92826162 2.91918496,3.79297408 2.91918496,3.62608721 L2.91918496,3.02173837 L1.7515121,3.02173837 C1.42906573,3.02173837 1.16767286,3.29231346 1.16767286,3.62608721 L1.16767286,4.8347675 L12.8444407,4.8347675 L12.8444407,3.62608721 C12.8444407,3.29231346 12.583031,3.02173837 12.2605847,3.02173837 L11.0929286,3.02173837 L11.0929286,3.62608721 C11.0929286,3.79297408 10.9622238,3.92826162 10.8009726,3.92826162 L10.2171726,3.92826162 C10.0559214,3.92826162 9.92521653,3.79297408 9.92521653,3.62608721 L9.92521653,3.02173837 Z M1.16767286,6.04348833 L12.8444407,6.04348833 L12.8444407,12.0869767 C12.8444407,12.4207504 12.583031,12.6912792 12.2605847,12.6912792 L1.7515121,12.6912792 C1.42906573,12.6912792 1.16767286,12.4207504 1.16767286,12.0869767 L1.16767286,6.04348833 Z"
                        id="Shape"
                      />
                    </g>
                    <g
                      id="SL/icons/icon/arrow-short"
                      transform="translate(200.000000, 18.000000)"
                      fill="#101010"
                      fillRule="nonzero"
                    >
                      <g id="iconfinder_trash-bin-garbage-delete-rubbish-waste_3643729">
                        <path
                          d="M10.5,15 L2.5,15 C1.67157288,15 1,14.3284271 1,13.5 L1,4 C1,3.72385763 1.22385763,3.5 1.5,3.5 C1.77614237,3.5 2,3.72385763 2,4 L2,13.5 C2,13.7761424 2.22385763,14 2.5,14 L10.5,14 C10.7761424,14 11,13.7761424 11,13.5 L11,4 C11,3.72385763 11.2238576,3.5 11.5,3.5 C11.7761424,3.5 12,3.72385763 12,4 L12,13.5 C12,14.3284271 11.3284271,15 10.5,15 Z"
                          id="Path"
                        />
                        <path
                          d="M12.5,3 L0.5,3 C0.223857625,3 0,2.77614237 0,2.5 C0,2.22385763 0.223857625,2 0.5,2 L12.5,2 C12.7761424,2 13,2.22385763 13,2.5 C13,2.77614237 12.7761424,3 12.5,3 Z"
                          id="Path"
                        />
                        <path
                          d="M8.5,3 C8.22385763,3 8,2.77614237 8,2.5 L8,1 L5,1 L5,2.5 C5,2.77614237 4.77614237,3 4.5,3 C4.22385763,3 4,2.77614237 4,2.5 L4,0.5 C4,0.223857625 4.22385763,0 4.5,0 L8.5,0 C8.77614237,0 9,0.223857625 9,0.5 L9,2.5 C9,2.77614237 8.77614237,3 8.5,3 Z"
                          id="Path"
                        />
                        <path
                          d="M6.5,12.5 C6.22385763,12.5 6,12.2761424 6,12 L6,5 C6,4.72385763 6.22385763,4.5 6.5,4.5 C6.77614237,4.5 7,4.72385763 7,5 L7,12 C7,12.2761424 6.77614237,12.5 6.5,12.5 Z"
                          id="Path"
                        />
                        <path
                          d="M9,11.5 C8.72385763,11.5 8.5,11.2761424 8.5,11 L8.5,6 C8.5,5.72385763 8.72385763,5.5 9,5.5 C9.27614237,5.5 9.5,5.72385763 9.5,6 L9.5,11 C9.5,11.2761424 9.27614237,11.5 9,11.5 Z"
                          id="Path"
                        />
                        <path
                          d="M4,11.5 C3.72385763,11.5 3.5,11.2761424 3.5,11 L3.5,6 C3.5,5.72385763 3.72385763,5.5 4,5.5 C4.27614237,5.5 4.5,5.72385763 4.5,6 L4.5,11 C4.5,11.2761424 4.27614237,11.5 4,11.5 Z"
                          id="Path"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <text
                id="Congés"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="0" y="13">
                  Congés
                </tspan>
              </text>
              <text
                id="Du"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="280" y="13">
                  Du
                </tspan>
              </text>
              <text
                id="Au"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="457" y="13">
                  Au
                </tspan>
              </text>
            </g>
            <g id="Group-7" transform="translate(3.000000, 170.000000)">
              <use
                id="Rectangle"
                stroke="#000000"
                mask="url(#mask-2)"
                strokeWidth="2"
                stroke-dasharray="4"
                xlinkHref="#path-1"
              />
              <text
                id="Ajouter-un-congé"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="16"
                fontWeight="bold"
                line-spacing="22"
                fill="#000000"
              >
                <tspan x="273.585938" y="29">
                  Ajouter un congé
                </tspan>
              </text>
            </g>
          </g>
          <g id="Group-9" transform="translate(296.000000, 964.000000)">
            <g id="Group-Copy">
              <g id="Group-5" transform="translate(0.000000, 27.000000)">
                <g id="Group-6">
                  <rect
                    id="Rectangle"
                    stroke="#999999"
                    fill="#FFFFFF"
                    x="0.5"
                    y="0.5"
                    width="261"
                    height="49"
                    rx="10"
                  />
                  <text
                    id="Semaine-de-ski"
                    fontFamily="Roboto-Medium, Roboto"
                    fontSize="16"
                    fontWeight="400"
                    fill="#000000"
                  >
                    <tspan x="16" y="30">
                      Semaine de ski
                    </tspan>
                  </text>
                  <g
                    id="SL/icons/icon/arrow-short"
                    transform="translate(229.753170, 21.246883)"
                    fill="#FFFFFF"
                  >
                    <path
                      d="M10.8985258,11.7530904 C10.6726895,11.7543568 10.4556255,11.6674184 10.2952828,11.5114658 L3.49817828,4.84634385 C3.33733105,4.68990794 3.24685677,4.47696074 3.24685677,4.25481428 C3.24685677,4.03266782 3.33733105,3.81972062 3.49817828,3.66328471 L10.2952828,-3.0018372 C10.6284447,-3.32852996 11.1686069,-3.32852996 11.5017689,-3.0018372 C11.8349308,-2.67514444 11.8349308,-2.14547082 11.5017689,-1.81877806 L5.29941098,4.25481428 L11.5017689,10.3284066 C11.6626161,10.4848425 11.7530904,10.6977897 11.7530904,10.9199362 C11.7530904,11.1420826 11.6626161,11.3550298 11.5017689,11.5114658 C11.3414261,11.6674184 11.1243622,11.7543568 10.8985258,11.7530904 Z"
                      id="Path"
                      transform="translate(7.499974, 4.253117) scale(1, -1) rotate(90.000000) translate(-7.499974, -4.253117) "
                    />
                  </g>
                </g>
                <g id="Group-6" transform="translate(277.000000, 0.000000)">
                  <rect
                    id="Rectangle"
                    stroke="#999999"
                    fill="#FFFFFF"
                    x="0.5"
                    y="0.5"
                    width="156"
                    height="49"
                    rx="10"
                  />
                  <text
                    id="06.02.2022"
                    fontFamily="Roboto-Medium, Roboto"
                    fontSize="16"
                    fontWeight="400"
                    fill="#000000"
                  >
                    <tspan x="50" y="31">
                      06.02.2022
                    </tspan>
                  </text>
                  <g
                    id="SL/icons/naked-icon"
                    transform="translate(19.483871, 18.500000)"
                    fill="#101010"
                  >
                    <path
                      d="M3.21110738,0 C3.04988419,0 2.91918496,0.135287542 2.91918496,0.302174417 L2.91918496,1.81304071 L1.16767286,1.81304071 C0.522785726,1.81304071 7.73574753e-15,2.35419667 7.73574753e-15,3.02173837 L7.73574753e-15,12.6912792 C7.73574753e-15,13.3588267 0.522785726,13.9 1.16767286,13.9 L12.8444407,13.9 C13.4893335,13.9 14.0120968,13.3588267 14.0120968,12.6912792 L14.0120968,3.02173837 C14.0120968,2.35419667 13.4893335,1.81304071 12.8444407,1.81304071 L11.0929286,1.81304071 L11.0929286,0.302174417 C11.0929286,0.135287542 10.9622238,0 10.8009726,0 L10.2171726,0 C10.0559214,0 9.92521653,0.135287542 9.92521653,0.302174417 L9.92521653,1.81304071 L4.08686343,1.81304071 L4.08686343,0.302174417 C4.08686343,0.135287542 3.95616419,0 3.79494101,0 L3.21110738,0 Z M9.92521653,3.02173837 L4.08686343,3.02173837 L4.08686343,3.62608721 C4.08686343,3.79297408 3.95616419,3.92826162 3.79494101,3.92826162 L3.21110738,3.92826162 C3.04988419,3.92826162 2.91918496,3.79297408 2.91918496,3.62608721 L2.91918496,3.02173837 L1.7515121,3.02173837 C1.42906573,3.02173837 1.16767286,3.29231346 1.16767286,3.62608721 L1.16767286,4.8347675 L12.8444407,4.8347675 L12.8444407,3.62608721 C12.8444407,3.29231346 12.583031,3.02173837 12.2605847,3.02173837 L11.0929286,3.02173837 L11.0929286,3.62608721 C11.0929286,3.79297408 10.9622238,3.92826162 10.8009726,3.92826162 L10.2171726,3.92826162 C10.0559214,3.92826162 9.92521653,3.79297408 9.92521653,3.62608721 L9.92521653,3.02173837 Z M1.16767286,6.04348833 L12.8444407,6.04348833 L12.8444407,12.0869767 C12.8444407,12.4207504 12.583031,12.6912792 12.2605847,12.6912792 L1.7515121,12.6912792 C1.42906573,12.6912792 1.16767286,12.4207504 1.16767286,12.0869767 L1.16767286,6.04348833 Z"
                      id="Shape"
                    />
                  </g>
                </g>
                <g id="Group-6" transform="translate(449.000000, 0.000000)">
                  <rect
                    id="Rectangle"
                    stroke="#999999"
                    fill="#FFFFFF"
                    x="0.5"
                    y="0.5"
                    width="156"
                    height="49"
                    rx="10"
                  />
                  <text
                    id="10.02.2022"
                    fontFamily="Roboto-Medium, Roboto"
                    fontSize="16"
                    fontWeight="400"
                    fill="#000000"
                  >
                    <tspan x="50" y="31">
                      10.02.2022
                    </tspan>
                  </text>
                  <g
                    id="SL/icons/naked-icon"
                    transform="translate(19.483871, 18.500000)"
                    fill="#101010"
                  >
                    <path
                      d="M3.21110738,0 C3.04988419,0 2.91918496,0.135287542 2.91918496,0.302174417 L2.91918496,1.81304071 L1.16767286,1.81304071 C0.522785726,1.81304071 7.73574753e-15,2.35419667 7.73574753e-15,3.02173837 L7.73574753e-15,12.6912792 C7.73574753e-15,13.3588267 0.522785726,13.9 1.16767286,13.9 L12.8444407,13.9 C13.4893335,13.9 14.0120968,13.3588267 14.0120968,12.6912792 L14.0120968,3.02173837 C14.0120968,2.35419667 13.4893335,1.81304071 12.8444407,1.81304071 L11.0929286,1.81304071 L11.0929286,0.302174417 C11.0929286,0.135287542 10.9622238,0 10.8009726,0 L10.2171726,0 C10.0559214,0 9.92521653,0.135287542 9.92521653,0.302174417 L9.92521653,1.81304071 L4.08686343,1.81304071 L4.08686343,0.302174417 C4.08686343,0.135287542 3.95616419,0 3.79494101,0 L3.21110738,0 Z M9.92521653,3.02173837 L4.08686343,3.02173837 L4.08686343,3.62608721 C4.08686343,3.79297408 3.95616419,3.92826162 3.79494101,3.92826162 L3.21110738,3.92826162 C3.04988419,3.92826162 2.91918496,3.79297408 2.91918496,3.62608721 L2.91918496,3.02173837 L1.7515121,3.02173837 C1.42906573,3.02173837 1.16767286,3.29231346 1.16767286,3.62608721 L1.16767286,4.8347675 L12.8444407,4.8347675 L12.8444407,3.62608721 C12.8444407,3.29231346 12.583031,3.02173837 12.2605847,3.02173837 L11.0929286,3.02173837 L11.0929286,3.62608721 C11.0929286,3.79297408 10.9622238,3.92826162 10.8009726,3.92826162 L10.2171726,3.92826162 C10.0559214,3.92826162 9.92521653,3.79297408 9.92521653,3.62608721 L9.92521653,3.02173837 Z M1.16767286,6.04348833 L12.8444407,6.04348833 L12.8444407,12.0869767 C12.8444407,12.4207504 12.583031,12.6912792 12.2605847,12.6912792 L1.7515121,12.6912792 C1.42906573,12.6912792 1.16767286,12.4207504 1.16767286,12.0869767 L1.16767286,6.04348833 Z"
                      id="Shape"
                    />
                  </g>
                  <g
                    id="SL/icons/icon/arrow-short"
                    transform="translate(200.000000, 18.000000)"
                    fill="#101010"
                    fillRule="nonzero"
                  >
                    <g id="iconfinder_trash-bin-garbage-delete-rubbish-waste_3643729">
                      <path
                        d="M10.5,15 L2.5,15 C1.67157288,15 1,14.3284271 1,13.5 L1,4 C1,3.72385763 1.22385763,3.5 1.5,3.5 C1.77614237,3.5 2,3.72385763 2,4 L2,13.5 C2,13.7761424 2.22385763,14 2.5,14 L10.5,14 C10.7761424,14 11,13.7761424 11,13.5 L11,4 C11,3.72385763 11.2238576,3.5 11.5,3.5 C11.7761424,3.5 12,3.72385763 12,4 L12,13.5 C12,14.3284271 11.3284271,15 10.5,15 Z"
                        id="Path"
                      />
                      <path
                        d="M12.5,3 L0.5,3 C0.223857625,3 0,2.77614237 0,2.5 C0,2.22385763 0.223857625,2 0.5,2 L12.5,2 C12.7761424,2 13,2.22385763 13,2.5 C13,2.77614237 12.7761424,3 12.5,3 Z"
                        id="Path"
                      />
                      <path
                        d="M8.5,3 C8.22385763,3 8,2.77614237 8,2.5 L8,1 L5,1 L5,2.5 C5,2.77614237 4.77614237,3 4.5,3 C4.22385763,3 4,2.77614237 4,2.5 L4,0.5 C4,0.223857625 4.22385763,0 4.5,0 L8.5,0 C8.77614237,0 9,0.223857625 9,0.5 L9,2.5 C9,2.77614237 8.77614237,3 8.5,3 Z"
                        id="Path"
                      />
                      <path
                        d="M6.5,12.5 C6.22385763,12.5 6,12.2761424 6,12 L6,5 C6,4.72385763 6.22385763,4.5 6.5,4.5 C6.77614237,4.5 7,4.72385763 7,5 L7,12 C7,12.2761424 6.77614237,12.5 6.5,12.5 Z"
                        id="Path"
                      />
                      <path
                        d="M9,11.5 C8.72385763,11.5 8.5,11.2761424 8.5,11 L8.5,6 C8.5,5.72385763 8.72385763,5.5 9,5.5 C9.27614237,5.5 9.5,5.72385763 9.5,6 L9.5,11 C9.5,11.2761424 9.27614237,11.5 9,11.5 Z"
                        id="Path"
                      />
                      <path
                        d="M4,11.5 C3.72385763,11.5 3.5,11.2761424 3.5,11 L3.5,6 C3.5,5.72385763 3.72385763,5.5 4,5.5 C4.27614237,5.5 4.5,5.72385763 4.5,6 L4.5,11 C4.5,11.2761424 4.27614237,11.5 4,11.5 Z"
                        id="Path"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <text
                id="Activités-spéciales"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="0" y="13">
                  Activités spéciales
                </tspan>
              </text>
              <text
                id="Du"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="280" y="13">
                  Du
                </tspan>
              </text>
              <text
                id="Au"
                opacity="0.65"
                fontFamily="Roboto-Regular, Roboto"
                fontSize="14"
                fontWeight="normal"
                fill="#000000"
              >
                <tspan x="451" y="13">
                  Au
                </tspan>
              </text>
            </g>
            <g id="Group-7" transform="translate(3.000000, 99.000000)">
              <use
                id="Rectangle"
                stroke="#000000"
                mask="url(#mask-4)"
                strokeWidth="2"
                stroke-dasharray="4"
                xlinkHref="#path-3"
              />
              <text
                id="Ajouter-un-congé"
                fontFamily="Roboto-Bold, Roboto"
                fontSize="16"
                fontWeight="bold"
                line-spacing="22"
                fill="#000000"
              >
                <tspan x="273.585938" y="29">
                  Ajouter un congé
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
    ),
    [nextStep, plan01StepCallback, planSettings05StepCallback],
  );

  const switchPlanStep = useCallback(step => {
    switch (step) {
      case 1:
        return step01;
      case 2:
        return step02;
      case 3:
        return step03;
      case 4:
        return step04;
      case 5:
        return step05;
    }
  }, []);

  // render function
  return <div className={childClassNames}>{switchPlanStep(planStep)}</div>;
}

export default memo(Plans);